import 'custom-event-polyfill';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _Symbol from '@babel/runtime-corejs3/core-js-stable/symbol';
import _getIteratorMethod from '@babel/runtime-corejs3/core-js/get-iterator-method';
import _getIterator from '@babel/runtime-corejs3/core-js/get-iterator';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _values from 'lodash/values';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _includes from 'lodash/includes';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _startsWith from 'lodash/startsWith';
import _set from 'lodash/set';
import _pickBy from 'lodash/pickBy';
import _omit from 'lodash/omit';
import _get from 'lodash/get';
import _each from 'lodash/each';
import axios from 'axios';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _isFunction from 'lodash/isFunction';
import _uniq from 'lodash/uniq';
import moment from 'moment-timezone';
import _isEqual from 'lodash/isEqual';
import _pick from 'lodash/pick';
import _keys from 'lodash/keys';
import _isArray from 'lodash/isArray';
import _cloneDeep from 'lodash/cloneDeep';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import _isString from 'lodash/isString';
import _isPlainObject from 'lodash/isPlainObject';
import _find from 'lodash/find';
import qs from 'qs';
import _Reflect$construct from '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _get$1 from '@babel/runtime-corejs3/helpers/get';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _isObject from 'lodash/isObject';
import _merge from 'lodash/merge';
import _isBoolean from 'lodash/isBoolean';
import _filter from 'lodash/filter';

(function () {
  if (window['rnw.locationchangeEventAdded']) {
    return;
  }

  window.history.pushState = function (f) {
    return function () {
      var ret = f.apply(this, arguments);
      window.dispatchEvent(new CustomEvent('rnw.pushstate'));
      window.dispatchEvent(new CustomEvent('rnw.locationchange'));
      return ret;
    };
  }(window.history.pushState);

  window.history.replaceState = function (f) {
    return function () {
      var ret = f.apply(this, arguments);
      window.dispatchEvent(new CustomEvent('rnw.replacestate'));
      window.dispatchEvent(new CustomEvent('rnw.locationchange'));
      return ret;
    };
  }(window.history.replaceState);

  window.addEventListener('popstate', function () {
    window.dispatchEvent(new CustomEvent('rnw.locationchange'));
  });
  window['rnw.locationchangeEventAdded'] = true;
})(); // https://stackoverflow.com/questions/56577201/why-is-isolatedmodules-error-fixed-by-any-import

var CreditCardIframeMessageType;

(function (CreditCardIframeMessageType) {
  CreditCardIframeMessageType["EPIK_CONFIG"] = "rnw.credit-card.sync-epik-config";
  CreditCardIframeMessageType["HEIGHT"] = "rnw.credit-card.height";
  CreditCardIframeMessageType["SET_LANGUAGE"] = "rnw.credit-card.set-language";
  CreditCardIframeMessageType["SET_FLOW"] = "rnw.credit-card.set-flow";
  CreditCardIframeMessageType["VALIDATE"] = "rnw.credit-card.validate";
  CreditCardIframeMessageType["VALIDATE_SUCCESS"] = "rnw.credit-card.validate:success";
  CreditCardIframeMessageType["VALIDATE_ERROR"] = "rnw.credit-card.validate:error";
  CreditCardIframeMessageType["TOKENIZE"] = "rnw.credit-card.tokenize";
  CreditCardIframeMessageType["TOKENIZE_SUCCESS"] = "rnw.credit-card.tokenize:success";
  CreditCardIframeMessageType["TOKENIZE_ERROR"] = "rnw.credit-card.tokenize:error";
  CreditCardIframeMessageType["DETECT_CREDIT_CARD_TYPE"] = "rnw.credit-card.detect-credit-card-type";
  CreditCardIframeMessageType["DATA_CHANGED"] = "rnw.credit-card.data:changed";
  CreditCardIframeMessageType["CREDIT_CARD_TYPE_CHANGED"] = "rnw.credit-card.credit-card-type:changed";
  CreditCardIframeMessageType["MARK_ALL_FIELDS_AS_TOUCHED"] = "rnw.credit-card.mark-all-fields-as-touched";
  CreditCardIframeMessageType["SUBMIT"] = "rnw.credit-card.submit";
})(CreditCardIframeMessageType || (CreditCardIframeMessageType = {}));

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = _getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { var _context3; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = _sliceInstanceProperty(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

///////////////////////////////////////////////////////////////////////////////
var EpikEventName;

(function (EpikEventName) {
  EpikEventName["FETCH_PAYMENT_DATA_START"] = "fetchPaymentDataStart";
  EpikEventName["FETCH_PAYMENT_DATA_END"] = "fetchPaymentDataEnd";
  EpikEventName["TRANSACTION_STATUS_POLL"] = "transactionStatusPoll";
  EpikEventName["SEND_EPP_PAYMENT_START"] = "sendEppPaymentStart";
  EpikEventName["SEND_EPMS_PAYMENT_START"] = "sendEpmsPaymentStart";
  EpikEventName["SEND_EPMS_PAYMENT_END"] = "sendEpmsPaymentEnd";
  EpikEventName["UPDATE_EPMS_SUBSCRIPTION_START"] = "updateEpmsSubscriptionStart";
  EpikEventName["UPDATE_EPMS_SUBSCRIPTION_END"] = "updateEpmsSubscriptionEnd";
})(EpikEventName || (EpikEventName = {}));

///////////////////////////////////////////////////////////////////////////////
var EpikEventer = /*#__PURE__*/function () {
  function EpikEventer(eventName) {
    _classCallCheck(this, EpikEventer);

    this.eventName = void 0;
    this.handlers = [];
    this.eventName = eventName;
  }

  _createClass(EpikEventer, [{
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var event, _iterator, _step, handler;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event = {
                  eventName: this.eventName
                };

                if (data) {
                  event.data = data;
                }

                _iterator = _createForOfIteratorHelper$1(this.handlers);
                _context.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 11;
                  break;
                }

                handler = _step.value;
                _context.next = 9;
                return handler(event);

              case 9:
                _context.next = 5;
                break;

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);

                _iterator.e(_context.t0);

              case 16:
                _context.prev = 16;

                _iterator.f();

                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 13, 16, 19]]);
      }));

      function publish(_x) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(handler) {
      var _this = this;

      this.handlers.push(handler);
      return function () {
        var idx = _this.handlers.indexOf(handler);

        if (idx !== -1) {
          var _context2;

          _spliceInstanceProperty(_context2 = _this.handlers).call(_context2, idx, 1);
        }
      };
    }
  }]);

  return EpikEventer;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEpikEvents = function createEpikEvents() {
  var result = {};

  var _iterator2 = _createForOfIteratorHelper$1(_values(EpikEventName)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var eventName = _step2.value;
      result[eventName] = new EpikEventer(eventName);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return result;
};

var EpikQueryParam; ///////////////////////////////////////////////////////////////////////////////

(function (EpikQueryParam) {
  EpikQueryParam["EPP_TRANSACTION_ID"] = "epp_transaction_id";
  EpikQueryParam["SUBSCRIPTION_TOKEN"] = "subscription_token";
  EpikQueryParam["CUSTOMER_TOKEN"] = "customer_token";
  EpikQueryParam["VIEW"] = "rnw-view";
  EpikQueryParam["EPMS_PAYMENT_UUID"] = "epms_payment_uuid";
  EpikQueryParam["EPMS_SUBSCRIPTION_UUID"] = "epms_subscription_uuid";
})(EpikQueryParam || (EpikQueryParam = {}));

var AllEpikQueryParams = [EpikQueryParam.EPP_TRANSACTION_ID, EpikQueryParam.SUBSCRIPTION_TOKEN, EpikQueryParam.CUSTOMER_TOKEN, EpikQueryParam.VIEW, EpikQueryParam.EPMS_PAYMENT_UUID, EpikQueryParam.EPMS_SUBSCRIPTION_UUID];
var WatchedEpikQueryParams = [EpikQueryParam.EPP_TRANSACTION_ID, EpikQueryParam.SUBSCRIPTION_TOKEN, EpikQueryParam.CUSTOMER_TOKEN, EpikQueryParam.EPMS_PAYMENT_UUID, EpikQueryParam.EPMS_SUBSCRIPTION_UUID];

var EpmsPaymentStatus;

(function (EpmsPaymentStatus) {
  EpmsPaymentStatus["PENDING"] = "pending";
  EpmsPaymentStatus["SUCCEEDED"] = "succeeded";
  EpmsPaymentStatus["FAILED"] = "failed";
  EpmsPaymentStatus["REFUNDED"] = "refunded";
  EpmsPaymentStatus["PARTIALLY_REFUNDED"] = "partially_refunded";
})(EpmsPaymentStatus || (EpmsPaymentStatus = {}));

var EpmsPaymentStatusReason;

(function (EpmsPaymentStatusReason) {
  EpmsPaymentStatusReason["NEW"] = "new";
  EpmsPaymentStatusReason["PENDING"] = "pending";
  EpmsPaymentStatusReason["UNKNOWN"] = "unknown";
  EpmsPaymentStatusReason["SUCCEEDED"] = "succeeded";
  EpmsPaymentStatusReason["ERROR"] = "error";
  EpmsPaymentStatusReason["USER_TIMEOUT"] = "user_timeout";
  EpmsPaymentStatusReason["ABORTED_BY_USER"] = "aborted_by_user";
  EpmsPaymentStatusReason["DECLINED"] = "declined";
  EpmsPaymentStatusReason["REFUNDED"] = "refunded";
  EpmsPaymentStatusReason["PARTIALLY_REFUNDED"] = "partially_refunded";
})(EpmsPaymentStatusReason || (EpmsPaymentStatusReason = {}));

///////////////////////////////////////////////////////////////////////////////
var EpmsSubscriptionStatus;

(function (EpmsSubscriptionStatus) {
  EpmsSubscriptionStatus["ACTIVE"] = "active";
  EpmsSubscriptionStatus["CANCELLED"] = "cancelled";
})(EpmsSubscriptionStatus || (EpmsSubscriptionStatus = {}));

var PaymentCurrency;

(function (PaymentCurrency) {
  PaymentCurrency["CHF"] = "chf";
  PaymentCurrency["EUR"] = "eur";
  PaymentCurrency["USD"] = "usd";
})(PaymentCurrency || (PaymentCurrency = {}));

var PaymentMethod; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentMethod) {
  PaymentMethod["CREDIT_CARD"] = "cc";
  PaymentMethod["AMERICAN_EXPRESS"] = "amx";
  PaymentMethod["CYMBA"] = "cym";
  PaymentMethod["DINERS_CLUB"] = "din";
  PaymentMethod["DIRECT_DEBIT"] = "dd";
  PaymentMethod["DISCOVERY"] = "dis";
  PaymentMethod["WEBBANKING_INDIA"] = "ebs";
  PaymentMethod["ELEKTRONISCHES_LASTSCHRIFTVERFAHREN"] = "elv";
  PaymentMethod["ELECTRONIC_PAYMENT_SERVICE"] = "eps";
  PaymentMethod["JAPANESE_CREDIT_BUREAU"] = "jcb";
  PaymentMethod["MAESTRO"] = "mae";
  PaymentMethod["MASTER_CARD"] = "eca";
  PaymentMethod["MASTER_PASS"] = "mpw";
  PaymentMethod["PAYMENT_SLIP"] = "es";
  PaymentMethod["PAYMENT_SLIP_WITH_REFERENCE_NUMBER"] = "ezs";
  PaymentMethod["PAY_PAL"] = "pp";
  PaymentMethod["POST_FINANCE"] = "pef";
  PaymentMethod["POST_FINANCE_CARD"] = "pfc";
  PaymentMethod["SEPA_ONE"] = "sod";
  PaymentMethod["SMS"] = "sms";
  PaymentMethod["SOFORT"] = "dib";
  PaymentMethod["STRIPE"] = "stp";
  PaymentMethod["TWINT"] = "twi";
  PaymentMethod["VISA"] = "vis";
  PaymentMethod["MPOS"] = "mpos";
  PaymentMethod["NARANJA"] = "naranja";
  PaymentMethod["TARJETA"] = "tarjeta";
  PaymentMethod["CABAL"] = "cabal";
  PaymentMethod["ARGENCARD"] = "argencard";
  PaymentMethod["CENCOSUD"] = "cencosud";
  PaymentMethod["HIPERCARD"] = "hipercard";
  PaymentMethod["CODENSA"] = "codensa";
  PaymentMethod["CREDENCIAL"] = "credencial";
})(PaymentMethod || (PaymentMethod = {}));

var CreditCardPaymentMethods = [PaymentMethod.CREDIT_CARD, PaymentMethod.AMERICAN_EXPRESS, PaymentMethod.DINERS_CLUB, PaymentMethod.DISCOVERY, PaymentMethod.JAPANESE_CREDIT_BUREAU, PaymentMethod.MAESTRO, PaymentMethod.MASTER_CARD, PaymentMethod.VISA, PaymentMethod.STRIPE, PaymentMethod.NARANJA, PaymentMethod.TARJETA, PaymentMethod.CABAL, PaymentMethod.ARGENCARD, PaymentMethod.CENCOSUD, PaymentMethod.HIPERCARD, PaymentMethod.CODENSA, PaymentMethod.CREDENCIAL];
var PostFinancePaymentMethods = [PaymentMethod.POST_FINANCE, PaymentMethod.POST_FINANCE_CARD];
var PaymentMethodsWithDeferredStatus = [PaymentMethod.SMS, PaymentMethod.MPOS];
var FallbackCreditCardPaymentMethod = PaymentMethod.VISA;
var isSupportedPaymentMethod = function isSupportedPaymentMethod(paymentMethod) {
  return _values(PaymentMethod).indexOf(paymentMethod) !== -1;
};
var isCreditCardPaymentMethod = function isCreditCardPaymentMethod(paymentMethod) {
  return CreditCardPaymentMethods.indexOf(paymentMethod) !== -1 || paymentMethod === 'card';
};
var isPostFinancePaymentMethod = function isPostFinancePaymentMethod(paymentMethod) {
  return PostFinancePaymentMethods.indexOf(paymentMethod) !== -1;
};
var isPaymentMethodWithDeferredStatus = function isPaymentMethodWithDeferredStatus(paymentMethod) {
  return PaymentMethodsWithDeferredStatus.indexOf(paymentMethod) !== -1;
};
var getCreditCardType = function getCreditCardType(cardNumber) {
  var paymentFlow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PaymentFlow.EPP;

  if (!cardNumber) {
    return null;
  }

  cardNumber = cardNumber.replace(/[A-z\s-]+/g, '');

  if (paymentFlow === PaymentFlow.EPMS) {
    if (cardNumber.match(/^589562/g)) {
      return PaymentMethod.NARANJA;
    }

    if (cardNumber.match(/^603488|^2799/g)) {
      return PaymentMethod.TARJETA;
    }

    if (cardNumber.match(/^(604([23][0-9][0-9])|400)|(^589657)/g)) {
      return PaymentMethod.CABAL;
    }

    if (cardNumber.match(/^(501105|532362)/g)) {
      return PaymentMethod.ARGENCARD;
    }

    if (cardNumber.match(/^603493/g)) {
      return PaymentMethod.CENCOSUD;
    }

    if (cardNumber.match(/^606282/g)) {
      return PaymentMethod.HIPERCARD;
    }

    if (cardNumber.match(/^590712/g)) {
      return PaymentMethod.CODENSA;
    }

    if (cardNumber.match(/^(541203|540625|549151)/g)) {
      return PaymentMethod.CREDENCIAL;
    }
  }

  if (cardNumber.match(/^(4)/g)) {
    return PaymentMethod.VISA;
  }

  if (cardNumber.match(/^(5[0-5])/g)) {
    return PaymentMethod.MASTER_CARD;
  }

  if (cardNumber.match(/^3[4|7]/g)) {
    return PaymentMethod.AMERICAN_EXPRESS;
  }

  if (cardNumber.match(/^36/g)) {
    return PaymentMethod.DINERS_CLUB;
  }

  if (cardNumber.match(/^6((011)|5)/g)) {
    return PaymentMethod.DISCOVERY;
  }

  if (cardNumber.match(/^(5[06789]|6)[0-9]{0,}$/g)) {
    return PaymentMethod.MAESTRO;
  }

  if (cardNumber.match(/^35/g)) {
    return PaymentMethod.JAPANESE_CREDIT_BUREAU;
  }

  return null;
};

///////////////////////////////////////////////////////////////////////////////
var PaymentProvider; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentProvider) {
  PaymentProvider["ADYEN"] = "adyen";
  PaymentProvider["DATATRANS"] = "datatrans";
  PaymentProvider["INGCOLLECT"] = "ingcollect";
  PaymentProvider["STRIPE"] = "stripe";
  PaymentProvider["PAYU"] = "payu";
})(PaymentProvider || (PaymentProvider = {}));

var isSupportedPaymentProvider = function isSupportedPaymentProvider(paymentProvider) {
  return _values(PaymentProvider).indexOf(paymentProvider) !== -1;
};

function ownKeys$3(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

///////////////////////////////////////////////////////////////////////////////
var SUPPORTER_FIELDS = {
  uuid: 'stored_customer_uuid',
  salutation: 'stored_customer_salutation',
  first_name: 'stored_customer_firstname',
  last_name: 'stored_customer_lastname',
  email: 'stored_customer_email',
  email_permission: 'stored_customer_email_permission',
  street: 'stored_customer_street',
  house_number: 'stored_customer_street_number',
  address_addendum: 'stored_customer_street2',
  postal_code: 'stored_customer_zip_code',
  city: 'stored_customer_city',
  country: 'stored_customer_country',
  region_level_1: 'stored_customer_state'
};
var SUPPORTER_METADATA_FIELDS = {
  post_office_box: 'stored_customer_pobox'
};
var RNW_INTEGRATION_FIELDS = {
  donation_receipt_requested: 'stored_customer_donation_receipt',
  message: 'stored_customer_message'
};
var RNW_PRODUCT_FIELDS = {
  name: 'stored_rnw_product_name',
  version: 'stored_rnw_product_version',
  uuid: 'stored_rnw_widget_uuid',
  source_url: 'stored_rnw_source_url'
};
var RNW_COVER_FEE_FIELDS = {
  fixed: 'stored_rnw_cover_fee_fixed',
  percentage: 'stored_rnw_cover_fee_percentage',
  amount: 'stored_rnw_cover_fee_amount'
};
var RNW_ANALYTICS_FIELDS = {
  suggested_amounts: 'stored_rnw_analytics_suggested_amounts',
  preselected_amount: 'stored_rnw_analytics_preselected_amount'
};
var IGNORED_FIELDS = ['stored_customer_birthdate']; ///////////////////////////////////////////////////////////////////////////////

var PaymentFlowEpms = /*#__PURE__*/function () {
  function PaymentFlowEpms() {
    _classCallCheck(this, PaymentFlowEpms);
  }

  _createClass(PaymentFlowEpms, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(epik, payment, window) {
        var epmsPaymentRequestData, returnUrl, _epmsPaymentRequestDa, epmsPaymentSourceRequestData, epmsSubscriptionUpdateRequestData, epmsPaymentSourceResponseData, payment_source_uuid, epmsPaymentResponseData;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return preparePaymentData(payment, epik);

              case 2:
                epmsPaymentRequestData = _context.sent;
                returnUrl = payment.return_url;

                if (!payment.epms_subscription_uuid) {
                  _context.next = 32;
                  break;
                }

                // update subscription
                epik.config.debug && console.debug('[epik] update subscription');
                _context.prev = 6;
                _context.next = 9;
                return epik.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_START].publish();

              case 9:
                epmsPaymentSourceRequestData = _omit(epmsPaymentRequestData, 'subscription'); // todo: skip it when it will be supported on backend side

                epmsSubscriptionUpdateRequestData = {
                  currency_identifier: epmsPaymentRequestData.amount.currency,
                  amount: epmsPaymentRequestData.amount.value,
                  timezone: epmsPaymentRequestData.subscription.timezone,
                  recurring_interval: (_epmsPaymentRequestDa = epmsPaymentRequestData.custom_parameters) === null || _epmsPaymentRequestDa === void 0 ? void 0 : _epmsPaymentRequestDa.rnw_recurring_interval_name
                };
                _context.next = 13;
                return createPaymentSource(epmsPaymentSourceRequestData, epik);

              case 13:
                epmsPaymentSourceResponseData = _context.sent;
                payment_source_uuid = _get(epmsPaymentSourceResponseData, 'objects.payment_source_uuid');
                _context.next = 17;
                return epik.epmsProxy.updateSubscription({
                  epmsSubscriptionUuid: payment.epms_subscription_uuid,
                  update: _objectSpread$3(_objectSpread$3({}, epmsSubscriptionUpdateRequestData), {}, {
                    payment_source_uuid: payment_source_uuid
                  })
                });

              case 17:
                _context.next = 19;
                return epik.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_END].publish({
                  epmsSubscriptionUuid: payment.epms_subscription_uuid,
                  returnUrl: returnUrl
                });

              case 19:
                _context.next = 30;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](6);
                epik.config.debug && console.debug('[epik] update subscription error');

                if (!(_context.t0.response && _context.t0.response.data)) {
                  _context.next = 29;
                  break;
                }

                _context.next = 27;
                return epik.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_END].publish({
                  error: _context.t0.response.data,
                  epmsSubscriptionUuid: payment.epms_subscription_uuid,
                  returnUrl: returnUrl
                });

              case 27:
                _context.next = 30;
                break;

              case 29:
                throw _context.t0;

              case 30:
                _context.next = 52;
                break;

              case 32:
                // send payment
                epik.config.debug && console.debug('[epik] send payment');
                _context.prev = 33;
                _context.next = 36;
                return epik.events[EpikEventName.SEND_EPMS_PAYMENT_START].publish({
                  epmsPaymentRequestData: epmsPaymentRequestData
                });

              case 36:
                _context.next = 38;
                return sendPayment(epmsPaymentRequestData, epik);

              case 38:
                epmsPaymentResponseData = _context.sent;
                _context.next = 41;
                return epik.events[EpikEventName.SEND_EPMS_PAYMENT_END].publish({
                  epmsPaymentRequestData: epmsPaymentRequestData,
                  epmsPaymentResponseData: epmsPaymentResponseData,
                  returnUrl: returnUrl
                });

              case 41:
                _context.next = 52;
                break;

              case 43:
                _context.prev = 43;
                _context.t1 = _context["catch"](33);
                epik.config.debug && console.debug('[epik] send payment error');

                if (!(_context.t1.response && _context.t1.response.data)) {
                  _context.next = 51;
                  break;
                }

                _context.next = 49;
                return epik.events[EpikEventName.SEND_EPMS_PAYMENT_END].publish({
                  epmsPaymentRequestData: epmsPaymentRequestData,
                  epmsPaymentResponseError: _context.t1.response.data,
                  returnUrl: returnUrl
                });

              case 49:
                _context.next = 52;
                break;

              case 51:
                throw _context.t1;

              case 52:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 21], [33, 43]]);
      }));

      function start(_x, _x2, _x3) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }]);

  return PaymentFlowEpms;
}(); ///////////////////////////////////////////////////////////////////////////////

var sendPayment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestData, epik) {
    var _yield$axios$request, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.request({
              url: epik.config.epmsApiUrl + '/pay',
              method: 'post',
              data: requestData
            });

          case 2:
            _yield$axios$request = _context2.sent;
            data = _yield$axios$request.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function sendPayment(_x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var createPaymentSource = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(requestData, epik) {
    var _yield$axios$request2, data;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.request({
              url: epik.config.epmsApiUrl + '/payment-sources',
              method: 'post',
              data: requestData
            });

          case 2:
            _yield$axios$request2 = _context3.sent;
            data = _yield$axios$request2.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function createPaymentSource(_x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

var preparePaymentData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payment, epik) {
    var data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = {};
            prepareMainInfo(data, payment, epik);
            prepareSupporter(data, payment);
            prepareRnwIntegration(data, payment);
            prepareRnwProduct(data, payment);
            prepareRnwCoverFee(data, payment);
            prepareRnwAnalytics(data, payment);
            prepareCustomParameters(data, payment);
            prepareRecurringInfo(data, payment);
            preparePaymentInfo(data, payment);
            return _context4.abrupt("return", data);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function preparePaymentData(_x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}(); ///////////////////////////////////////////////////////////////////////////////


var prepareMainInfo = function prepareMainInfo(data, payment, epik) {
  if (payment.profile) {
    data.profile = payment.profile;
  }

  data.account_uuid = epik.config.epmsAccountUuid;
  data.test_mode = payment.test_mode;
  data.return_url = payment.return_url;
  data.locale = payment.language;
  data.create_supporter = !!payment.create_supporter;
  data.supporter = payment.supporter || {};
  data.raisenow = payment.raisenow || {};
  data.custom_parameters = payment.custom_parameters || {};
  data.payment_information = payment.payment_information || {};
  data.create_payment_source = !!payment.create_payment_source;
  data.amount = {
    value: payment.amount,
    currency: payment.currency.toUpperCase()
  };
};

var prepareSupporter = function prepareSupporter(data, payment) {
  var _context5;

  _each(SUPPORTER_FIELDS, function (v, k) {
    var existingValue = _get(data, "supporter.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      _set(data, "supporter.".concat(k), payment[v]);
    }
  });

  _each(SUPPORTER_METADATA_FIELDS, function (v, k) {
    var existingValue = _get(data, "supporter.metadata.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      _set(data, "supporter.metadata.".concat(k), payment[v]);
    }
  }); // Add fields with "stored_customer_" prefix
  // (except specified ones)
  // to "customer.metadata"


  var info = _pickBy(payment, function (v, k) {
    return _startsWith(k, 'stored_customer_');
  });

  info = _omit(info, _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(_values(SUPPORTER_FIELDS)), _toConsumableArray(_values(SUPPORTER_METADATA_FIELDS)), _toConsumableArray(_values(RNW_INTEGRATION_FIELDS)), _toConsumableArray(_values(RNW_PRODUCT_FIELDS)), IGNORED_FIELDS));

  _each(info, function (v, k) {
    var key = k.replace(/^stored_customer_/, '');

    var existingValue = _get(data, "supporter.metadata.".concat(key)); // don't override if field is already set


    if (v !== undefined && existingValue === undefined) {
      _set(data, "supporter.metadata.".concat(key), v);
    }
  }); // Split stored_customer_birthdate


  if (payment.stored_customer_birthdate) {
    var _payment$stored_custo = payment.stored_customer_birthdate.split('-'),
        _payment$stored_custo2 = _slicedToArray(_payment$stored_custo, 3),
        birth_year = _payment$stored_custo2[0],
        birth_month = _payment$stored_custo2[1],
        birth_day = _payment$stored_custo2[2];

    if (birth_year) {
      _set(data, "supporter.metadata.birth_year", birth_year);
    }

    if (birth_month) {
      _set(data, "supporter.metadata.birth_month", birth_month);
    }

    if (birth_day) {
      _set(data, "supporter.metadata.birth_day", birth_day);
    }
  }
};

var prepareRnwIntegration = function prepareRnwIntegration(data, payment) {
  _each(RNW_INTEGRATION_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.integration.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // value is casted to string
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.integration.".concat(k), '' + payment[v]);
    }
  });
};

var prepareRnwProduct = function prepareRnwProduct(data, payment) {
  _each(RNW_PRODUCT_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.product.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.product.".concat(k), '' + payment[v]);
    }
  });
};

var prepareRnwCoverFee = function prepareRnwCoverFee(data, payment) {
  _each(RNW_COVER_FEE_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.cover_fee.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.cover_fee.".concat(k), '' + payment[v]);
    }
  });
};

var prepareRnwAnalytics = function prepareRnwAnalytics(data, payment) {
  _each(RNW_ANALYTICS_FIELDS, function (v, k) {
    var existingValue = _get(payment, "raisenow.analytics.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      // todo: refactor with payment team to not cast values
      _set(data, "raisenow.analytics.".concat(k), '' + payment[v]);
    }
  });
};

var prepareCustomParameters = function prepareCustomParameters(data, payment) {
  var _context6;

  // Add fields with "stored_" prefix
  // (except ones with "stored_customer_" prefix and some others)
  // to "custom_parameters"
  var info = _pickBy(payment, function (v, k) {
    return _startsWith(k, 'stored_') && !_startsWith(k, 'stored_customer_');
  });

  info = _omit(info, _concatInstanceProperty(_context6 = []).call(_context6, _toConsumableArray(_values(SUPPORTER_FIELDS)), _toConsumableArray(_values(SUPPORTER_METADATA_FIELDS)), _toConsumableArray(_values(RNW_INTEGRATION_FIELDS)), _toConsumableArray(_values(RNW_PRODUCT_FIELDS)), _toConsumableArray(_values(RNW_COVER_FEE_FIELDS)), _toConsumableArray(_values(RNW_ANALYTICS_FIELDS)), IGNORED_FIELDS));

  _each(info, function (v, k) {
    var key = k.replace(/^stored_/, '');

    var existingValue = _get(data, "custom_parameters.".concat(key)); // don't override if field is already set


    if (v !== undefined && existingValue === undefined) {
      _set(data, "custom_parameters.".concat(key), v);
    }
  });
};

var prepareRecurringInfo = function prepareRecurringInfo(data, payment) {
  if (payment.recurring || payment.stored_pseudo_recurring) {
    var timezone;

    try {
      // not supported in ie11
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {}

    if (!timezone) {
      // use fallback
      timezone = 'Europe/Zurich';
    }

    data.subscription = {
      recurring_interval: payment.recurring_interval,
      timezone: timezone
    };
  }
};

var preparePaymentInfo = function preparePaymentInfo(data, payment) {
  prepareTwint(data, payment);
  preparePayu(data, payment);
  prepareStripe(data, payment);
}; ///////////////////////////////////////////////////////////////////////////////


var prepareTwint = function prepareTwint(data, payment) {
  var isTwint = payment.payment_method === PaymentMethod.TWINT;

  if (isTwint) {
    data.payment_method = 'twint';
  }
};

var preparePayu = function preparePayu(data, payment) {
  var isPayu = isCreditCardPaymentMethod(payment.payment_method) && payment.payment_provider === PaymentProvider.PAYU;

  if (isPayu) {
    data.statement_descriptor = payment.statement_descriptor;
    prepareCcPaymentInformation(data, payment);
    preparePayuPaymentInformationPayer(data, payment);
  }
};

var prepareStripe = function prepareStripe(data, payment) {
  var isStripe = isCreditCardPaymentMethod(payment.payment_method) && payment.payment_provider === PaymentProvider.STRIPE;

  if (isStripe) {
    prepareCcPaymentInformation(data, payment);
  }
}; ///////////////////////////////////////////////////////////////////////////////


var prepareCcPaymentInformation = function prepareCcPaymentInformation(data, payment) {
  var PAYMENT_INFORMATION_FIELDS = {
    cardholder: 'card_holder_name',
    number: 'cardno',
    expiry_month: 'expm',
    expiry_year: 'expy',
    cvv: 'cvv',
    card_token: 'card_token',
    brand_code: 'payment_method'
  };

  _each(PAYMENT_INFORMATION_FIELDS, function (v, k) {
    var existingValue = _get(data, "payment_information.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      _set(data, "payment_information.".concat(k), payment[v]);
    }
  });
};

var preparePayuPaymentInformationPayer = function preparePayuPaymentInformationPayer(data, payment) {
  var PAYMENT_INFORMATION_PAYER_FIELDS = {
    firstname: 'stored_customer_firstname',
    lastname: 'stored_customer_lastname',
    email: 'stored_customer_email',
    birth_date: 'stored_customer_birthdate',
    phone_number: 'stored_customer_phone',
    // ?
    street: 'stored_customer_street',
    house_number: 'stored_customer_street_number',
    postal_code: 'stored_customer_zip_code',
    city: 'stored_customer_city',
    country: 'stored_customer_country',
    state: 'stored_customer_state',
    document_number: 'stored_customer_document_number',
    document_type: 'stored_customer_document_type',
    company_identification_number: 'stored_customer_company_identification_number' // accept_terms_and_conditions: true, // Only for Brazil if the merchant's bank account is not Brazilian.

  };

  _each(PAYMENT_INFORMATION_PAYER_FIELDS, function (v, k) {
    var existingValue = _get(data, "payment_information.payer.".concat(k)); // don't override if field is already set


    if (payment[v] !== undefined && existingValue === undefined) {
      _set(data, "payment_information.payer.".concat(k), payment[v]);
    }
  });
};

///////////////////////////////////////////////////////////////////////////////
var createAndInjectIframe = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(document, options, targetSelector) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new _Promise(function (resolve, reject) {
              options = options || {};
              var iframe = document.createElement('iframe');

              if (options.name) {
                iframe.setAttribute('name', options.name);
              }

              if (options.src) {
                iframe.setAttribute('src', options.src);
              }

              if (options.style) {
                iframe.setAttribute('style', options.style);
              }

              if (options.hidden === true) {
                iframe.setAttribute('style', 'display: none;');
              }

              iframe.onload = function (event) {
                if (options && _isFunction(options.onload)) {
                  options.onload(iframe);
                }

                resolve(iframe);
              };

              injectHtmlElement(document, iframe, targetSelector);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createAndInjectIframe(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var createForm = function createForm(document, options) {
  var form = document.createElement('form');
  options = options || {};
  options.target = options.target || '_self';
  options.method = options.method || 'post';
  form.target = options.target;
  form.method = options.method;

  if (options.action) {
    form.action = options.action;
  }

  if (options.hidden === true) {
    form.setAttribute('style', 'display: none;');
  }

  return form;
};
var createAndInjectForm = function createAndInjectForm(document, options, targetSelector) {
  var form = createForm(document, options);
  injectHtmlElement(document, form, targetSelector);
  return form;
};
var injectHtmlElement = function injectHtmlElement(document, element, targetSelector) {
  if (targetSelector) {
    var target = document.querySelector(targetSelector);

    if (!target) {
      throw new Error('Could not inject element, target selector "' + targetSelector + '" is invalid');
    } // clear previous contents


    target.innerHTML = '';
    target.appendChild(element);
  } else {
    document.body.appendChild(element);
  }
};
var fillForm = function fillForm(document, form, data) {
  for (var _key in data) {
    var value = data[_key];
    var input = document.createElement('input');
    input.setAttribute('type', 'text');
    input.setAttribute('name', _key);
    input.setAttribute('placeholder', _key);
    input.setAttribute('value', value);
    form.appendChild(input);
  }
};

var PaymentFlowEpp = /*#__PURE__*/function () {
  function PaymentFlowEpp() {
    _classCallCheck(this, PaymentFlowEpp);
  }

  _createClass(PaymentFlowEpp, [{
    key: "start",
    value: function start(epik, payment, window) {
      return new _Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var url, form;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return epik.events[EpikEventName.SEND_EPP_PAYMENT_START].publish({
                    eppPaymentRequestData: payment
                  });

                case 2:
                  url = epik.config.eppApiUrl + '/epayment/api/step/pay/merchant/' + epik.config.eppApiKey;
                  form = createAndInjectForm(window.document, {
                    target: '_self',
                    method: 'post',
                    action: url,
                    hidden: true
                  });
                  fillForm(window.document, form, payment);
                  form.submit(); // don't resolve here so let form submit

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }]);

  return PaymentFlowEpp;
}();

var _context;

var PaymentFlow; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentFlow) {
  PaymentFlow["EPP"] = "epp";
  PaymentFlow["EPMS"] = "epms";
})(PaymentFlow || (PaymentFlow = {}));

var EppFlowPaymentMethods = [PaymentMethod.CREDIT_CARD, PaymentMethod.AMERICAN_EXPRESS, PaymentMethod.CYMBA, PaymentMethod.DINERS_CLUB, PaymentMethod.DIRECT_DEBIT, PaymentMethod.DISCOVERY, PaymentMethod.WEBBANKING_INDIA, PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN, PaymentMethod.ELECTRONIC_PAYMENT_SERVICE, PaymentMethod.JAPANESE_CREDIT_BUREAU, PaymentMethod.MAESTRO, PaymentMethod.MASTER_CARD, PaymentMethod.MASTER_PASS, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER, PaymentMethod.PAY_PAL, PaymentMethod.POST_FINANCE, PaymentMethod.POST_FINANCE_CARD, PaymentMethod.SEPA_ONE, PaymentMethod.SMS, PaymentMethod.SOFORT, PaymentMethod.STRIPE, PaymentMethod.TWINT, PaymentMethod.VISA, PaymentMethod.MPOS];

var EpmsFlowPaymentMethods = _concatInstanceProperty(_context = [PaymentMethod.TWINT]).call(_context, _toConsumableArray(CreditCardPaymentMethods));

var getSupportedPaymentFlows = function getSupportedPaymentFlows(paymentMethod) {
  if (!isSupportedPaymentMethod(paymentMethod)) {
    throw new Error('Payment method "' + paymentMethod + '" is not supported');
  }

  var flows = [];

  if (_includes(EppFlowPaymentMethods, paymentMethod)) {
    flows.push(PaymentFlow.EPP);
  }

  if (_includes(EpmsFlowPaymentMethods, paymentMethod)) {
    flows.push(PaymentFlow.EPMS);
  }

  if (flows.length === 0) {
    throw new Error('Payment method "' + paymentMethod + '" is not supported by any payment flow');
  }

  return flows;
};
var createPaymentFlow = function createPaymentFlow(paymentFlow) {
  if (paymentFlow === PaymentFlow.EPP) {
    return new PaymentFlowEpp();
  } else if (paymentFlow === PaymentFlow.EPMS) {
    return new PaymentFlowEpms();
  }

  throw new Error('Payment flow "' + paymentFlow + '" is not supported');
};

var PaymentType; ///////////////////////////////////////////////////////////////////////////////

(function (PaymentType) {
  PaymentType["ONE_TIME"] = "onetime";
  PaymentType["RECURRING"] = "recurring";
})(PaymentType || (PaymentType = {}));

var OneTimePaymentMethods = [PaymentMethod.WEBBANKING_INDIA, PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN, PaymentMethod.ELECTRONIC_PAYMENT_SERVICE, PaymentMethod.JAPANESE_CREDIT_BUREAU, // cc
PaymentMethod.MAESTRO, // cc
PaymentMethod.MASTER_PASS, PaymentMethod.POST_FINANCE, PaymentMethod.SMS, PaymentMethod.SOFORT, PaymentMethod.TWINT, PaymentMethod.MPOS];
var RecurringPaymentMethods = [PaymentMethod.CREDIT_CARD, PaymentMethod.AMERICAN_EXPRESS, PaymentMethod.CYMBA, PaymentMethod.DINERS_CLUB, PaymentMethod.DISCOVERY, PaymentMethod.MASTER_CARD, PaymentMethod.PAY_PAL, PaymentMethod.POST_FINANCE_CARD, PaymentMethod.SEPA_ONE, PaymentMethod.VISA, PaymentMethod.STRIPE, PaymentMethod.MPOS];
var PseudoRecurringPaymentMethods = [PaymentMethod.DIRECT_DEBIT, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER];
var getSupportedPaymentTypes = function getSupportedPaymentTypes(paymentMethod) {
  if (!isSupportedPaymentMethod(paymentMethod)) {
    throw new Error('Payment method "' + paymentMethod + '" is not supported');
  }

  var paymentTypes = [];

  if (_includes(OneTimePaymentMethods, paymentMethod)) {
    paymentTypes.push(PaymentType.ONE_TIME);
  }

  if (_includes(RecurringPaymentMethods, paymentMethod)) {
    paymentTypes.push(PaymentType.RECURRING);
  }

  if (_includes(PseudoRecurringPaymentMethods, paymentMethod)) {
    paymentTypes.push(PaymentType.RECURRING);
  }

  return _uniq(paymentTypes);
};
var isPaymentTypeSupported = function isPaymentTypeSupported(paymentMethod, paymentType) {
  return _includes(getSupportedPaymentTypes(paymentMethod), paymentType);
};

var RecurringInterval;

(function (RecurringInterval) {
  RecurringInterval["DAILY"] = "daily";
  RecurringInterval["WEEKLY"] = "weekly";
  RecurringInterval["MONTHLY"] = "monthly";
  RecurringInterval["QUARTERLY"] = "quarterly";
  RecurringInterval["SEMESTRAL"] = "semestral";
  RecurringInterval["YEARLY"] = "yearly";
})(RecurringInterval || (RecurringInterval = {}));

///////////////////////////////////////////////////////////////////////////////
var SubscriptionStatus;

(function (SubscriptionStatus) {
  SubscriptionStatus["ACTIVE"] = "active";
  SubscriptionStatus["INACTIVE"] = "inactive";
})(SubscriptionStatus || (SubscriptionStatus = {}));

///////////////////////////////////////////////////////////////////////////////
var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["SUCCESS"] = "success";
  TransactionStatus["ERROR"] = "error";
  TransactionStatus["CANCEL"] = "cancel";
  TransactionStatus["PENDING"] = "pending";
})(TransactionStatus || (TransactionStatus = {}));

var CronHelper = /*#__PURE__*/function () {
  function CronHelper() {
    _classCallCheck(this, CronHelper);
  }

  _createClass(CronHelper, [{
    key: "getRecurringIntervalExpression",
    value: function getRecurringIntervalExpression(recurringInterval) {
      var now = moment().tz('Europe/Zurich');
      var weekday = now.day();
      var date = now.date();
      var month = now.month() + 1; // js months are zero based 0-11
      // format is 'date of moth, month, weekday'

      if (recurringInterval === RecurringInterval.DAILY) {
        return ['*', '*', '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.WEEKLY) {
        return ['*', '*', weekday].join(' ');
      } else if (recurringInterval === RecurringInterval.MONTHLY) {
        return [date, '*', '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.QUARTERLY) {
        var months = this.getMonthsSequence(month, 4).join(',');
        return [date, months, '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.SEMESTRAL) {
        var _months = this.getMonthsSequence(month, 2).join(',');

        return [date, _months, '*'].join(' ');
      } else if (recurringInterval === RecurringInterval.YEARLY) {
        return [date, month, '*'].join(' ');
      }

      return recurringInterval;
    }
  }, {
    key: "getMonthsSequence",
    value: function getMonthsSequence(startMonth, repeatsInYear) {
      if (startMonth < 1 || startMonth > 12) {
        throw new Error('Invalid start month, must be one of: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12');
      }

      if (12 % repeatsInYear !== 0) {
        throw new Error('Invalid number of repeats, must be one of: 1, 2, 3, 4, 6');
      }

      var interval = 12 / repeatsInYear;
      var relativeOffset = startMonth - 1;
      var months = [];

      for (var i = 0; i < 12; i += interval) {
        var month = relativeOffset + i;
        var monthBelow12 = month % 12;
        var monthAbove0 = monthBelow12 + 1;
        months.push(monthAbove0);
      }

      return months;
    }
  }]);

  return CronHelper;
}(); ///////////////////////////////////////////////////////////////////////////////

var createCronHelper = function createCronHelper() {
  return new CronHelper();
};

var findDefinedValue = function findDefinedValue() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return _find(values, function (v) {
    return v !== null && v !== undefined && v !== '';
  });
};
var normalizeValues = function normalizeValues(data) {
  if (_isString(data)) {
    try {
      data = decodeURIComponent(data);
    } catch (error) {}

    if (data.toLowerCase() === 'null') {
      return null;
    }

    if (data.toLowerCase() === 'true') {
      return true;
    }

    if (data.toLowerCase() === 'false') {
      return false;
    }

    if (data.toLowerCase() === 'undefined') {
      return undefined;
    }
  }

  if (_isArray(data)) {
    return _map(data, function (v) {
      return normalizeValues(v);
    });
  }

  if (_isPlainObject(data)) {
    return _reduce(data, function (res, v, k) {
      res[k] = normalizeValues(v);
      return res;
    }, {});
  }

  return data;
};
var cleanBlankFields = function cleanBlankFields(payment) {
  _each(payment, function (v, k) {
    if (v === undefined || v === 'undefined' || v === null || v === 'null') {
      payment[k] = '';
    }
  });
}; ///////////////////////////////////////////////////////////////////////////////

var prepareReturnUrl = function prepareReturnUrl(href) {
  var url = document.createElement('a');
  url.href = href;
  var params = qs.parse(url.search, {
    ignoreQueryPrefix: true
  });
  delete params[EpikQueryParam.VIEW];
  delete params[EpikQueryParam.EPP_TRANSACTION_ID];
  delete params[EpikQueryParam.SUBSCRIPTION_TOKEN];
  delete params[EpikQueryParam.CUSTOMER_TOKEN];
  delete params[EpikQueryParam.EPMS_PAYMENT_UUID];
  delete params[EpikQueryParam.EPMS_SUBSCRIPTION_UUID];
  url.search = qs.stringify(params, {
    addQueryPrefix: true,
    strictNullHandling: true
  });
  return url.href;
};
var updateUrlParams = function updateUrlParams(href, data) {
  var url = document.createElement('a');
  url.href = href;
  var params = qs.parse(url.search, {
    ignoreQueryPrefix: true
  });

  _each(data, function (v, k) {
    params[k] = v;
  });

  url.search = qs.stringify(params, {
    addQueryPrefix: true,
    strictNullHandling: true
  });
  return url.href;
}; ///////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////
var getLocationParams = function getLocationParams(router) {
  var _router$getLocation = router.getLocation(),
      search = _router$getLocation.search;

  return qs.parse(search, {
    ignoreQueryPrefix: true
  });
};
var getUpdatedLocation = function getUpdatedLocation(router) {
  return function (args) {
    var _router$getLocation2 = router.getLocation(),
        currentPathname = _router$getLocation2.pathname,
        currentSearch = _router$getLocation2.search,
        currentHash = _router$getLocation2.hash;

    var currentParams = qs.parse(currentSearch, {
      ignoreQueryPrefix: true
    });
    var newPathname = args.pathname,
        newParams = args.params,
        newHash = args.hash;

    if (newPathname === undefined) {
      newPathname = currentPathname;
    }

    if (newHash === undefined) {
      newHash = currentHash;
    }

    _each(newParams, function (v, k) {
      currentParams[k] = v;

      if (v === undefined) {
        delete currentParams[k];
      }
    });

    var newSearch = qs.stringify(currentParams, {
      addQueryPrefix: true
    });
    return {
      pathname: newPathname,
      search: newSearch,
      hash: newHash
    };
  };
};
var getUpdatedUrl = function getUpdatedUrl(router) {
  return function (args) {
    var _getUpdatedLocation = getUpdatedLocation(router)(args),
        pathname = _getUpdatedLocation.pathname,
        search = _getUpdatedLocation.search,
        hash = _getUpdatedLocation.hash;

    return pathname + search + hash;
  };
};
var prepareExpirationYear = function prepareExpirationYear(input, flow) {
  var expy = parseInt(input);

  if (isNaN(expy)) {
    return input;
  } // for epp - YY, for epms - YYYY


  expy = flow === PaymentFlow.EPP && expy > 2000 ? expy - 2000 : expy;
  expy = flow === PaymentFlow.EPMS && expy < 2000 ? expy + 2000 : expy;
  return expy.toString();
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = _getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context5; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
///////////////////////////////////////////////////////////////////////////////
var Eventer = /*#__PURE__*/function () {
  function Eventer() {
    _classCallCheck(this, Eventer);

    this.debug = false;
    this.listeners = {};
    this.responders = {};
  }

  _createClass(Eventer, [{
    key: "emit",
    value: function emit(topic, data) {
      this.emitMessage(topic, this.createPayload(data));
    }
  }, {
    key: "on",
    value: function on(topic, listener) {
      if (!_isFunction(listener)) {
        throw new Error('Event listener must be a function');
      }

      if (!this.listeners[topic]) {
        this.listeners[topic] = [];
      }

      this.listeners[topic].push(listener);
    }
  }, {
    key: "simulate",
    value: function simulate(topic, data) {
      this.receiveMessage(topic, data);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, data, listener) {
        var respondTo, promise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(listener && !_isFunction(listener))) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Event listener must be a function');

              case 2:
                respondTo = topic + '-response-' + Date.now();
                promise = this.once(respondTo, listener);
                this.emitMessage(topic, this.createPayload(data, respondTo));
                return _context.abrupt("return", promise);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "respond",
    value: function respond(topic, responder) {
      if (!_isFunction(responder)) {
        throw new Error('Event responder must be a function');
      }

      if (!this.responders[topic]) {
        this.responders[topic] = [];
      }

      this.responders[topic].push(responder);
    }
  }, {
    key: "once",
    value: function () {
      var _once = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(topic, listener) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new _Promise(function (resolve, reject) {
                  var onceListener = function onceListener(data) {
                    _this.off(topic, onceListener);

                    if (listener) {
                      listener(data, topic);
                    }

                    resolve(data);
                  };

                  _this.on(topic, onceListener);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function once(_x4, _x5) {
        return _once.apply(this, arguments);
      }

      return once;
    }()
  }, {
    key: "off",
    value: function off(topic, listener) {
      var listeners = this.listeners[topic] || [];
      var responders = this.responders[topic] || [];

      for (var _key in listeners) {
        if (listeners[_key] === listener) {
          var _context3;

          _spliceInstanceProperty(_context3 = this.listeners[topic]).call(_context3, parseInt(_key), 1);

          return;
        }
      }

      for (var _key2 in responders) {
        if (responders[_key2] === listener) {
          var _context4;

          _spliceInstanceProperty(_context4 = this.responders[topic]).call(_context4, parseInt(_key2), 1);

          return;
        }
      }
    }
  }, {
    key: "emitMessage",
    value: function emitMessage(topic, payload) {
      this.debug && console.debug('[epik] eventer emit', {
        topic: topic,
        data: _cloneDeep(payload)
      });
      this.notifyListeners(topic, _cloneDeep(payload));
      this.notifyResponders(topic, _cloneDeep(payload));
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(topic, payload) {
      this.debug && console.debug('[epik] eventer receive', {
        topic: topic,
        data: _cloneDeep(payload)
      });
      this.notifyListeners(topic, _cloneDeep(payload));
      this.notifyResponders(topic, _cloneDeep(payload));
    }
  }, {
    key: "notifyListeners",
    value: function notifyListeners(topic, payload) {
      var _this$parsePayload = this.parsePayload(payload),
          data = _this$parsePayload.data;

      if (topic !== '*') {
        this.notifyListeners('*', payload);
      }

      var listeners = this.listeners[topic];

      if (listeners) {
        var _iterator = _createForOfIteratorHelper(listeners),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _listener = _step.value;

            _listener(data, topic);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "notifyResponders",
    value: function notifyResponders(topic, payload) {
      var _this2 = this;

      var _this$parsePayload2 = this.parsePayload(payload),
          data = _this$parsePayload2.data,
          respondTo = _this$parsePayload2.respondTo;

      var responders = this.responders[topic];

      if (responders) {
        var _iterator2 = _createForOfIteratorHelper(responders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _responder = _step2.value;
            var response = void 0;

            try {
              response = _responder(data, topic);
            } catch (error) {
              console.error(error);
            }

            if (respondTo) {
              if (response && response.then) {
                response.then(function (resolvedResponse) {
                  var _this2$parsePayload = _this2.parsePayload(resolvedResponse),
                      data = _this2$parsePayload.data;

                  _this2.emit(respondTo, data);
                })["catch"](function (error) {
                  console.error(error);

                  _this2.emit(respondTo, {
                    error: error
                  });
                });
              } else {
                var _this$parsePayload3 = this.parsePayload(response),
                    _data = _this$parsePayload3.data;

                this.emit(respondTo, _data);
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "createPayload",
    value: function createPayload(data, respondTo) {
      if (!_isObject(data)) {
        data = {
          __rawData: data
        };
      }

      if (respondTo) {
        data.__respondTo = respondTo;
      }

      return data;
    }
  }, {
    key: "parsePayload",
    value: function parsePayload(payload) {
      payload = payload || {
        __rawData: null
      };
      var respondTo = payload.__respondTo || null;
      delete payload.__respondTo;
      var data = payload.__rawData || payload.__rawData === null ? payload.__rawData : payload;
      return {
        data: data,
        respondTo: respondTo
      };
    }
  }]);

  return Eventer;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

///////////////////////////////////////////////////////////////////////////////
var Messenger = /*#__PURE__*/function (_Eventer) {
  _inherits(Messenger, _Eventer);

  var _super = _createSuper(Messenger);

  function Messenger() {
    var _this;

    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Messenger);

    _this = _super.call(this);
    _this.listenTo = void 0;
    _this.emitTo = void 0;
    _this.channel = void 0;
    _this.label = void 0;
    _this.postMessageListenerAttached = false;
    var listenTo = args.listenTo,
        emitTo = args.emitTo,
        channel = args.channel,
        label = args.label,
        debug = args.debug;
    _this.listenTo = listenTo || null;
    _this.emitTo = emitTo || null;
    _this.channel = channel || null;
    _this.label = label || null;
    _this.debug = !!debug;

    if (listenTo && listenTo === emitTo) {
      console.error('Messenger received two windows of the same instance, this is probably an error, since you want one window to be your main window and the other to be an iframe');
    }

    _this.postMessageListener = _this.postMessageListener.bind(_assertThisInitialized(_this));

    _this.setupPostMessageListener();

    return _this;
  }

  _createClass(Messenger, [{
    key: "emit",
    value: function emit(topic, data) {
      if (!this.emitTo) return;

      _get$1(_getPrototypeOf(Messenger.prototype), "emit", this).call(this, topic, data);
    }
  }, {
    key: "on",
    value: function on(topic, listener) {
      if (!this.listenTo) return;

      _get$1(_getPrototypeOf(Messenger.prototype), "on", this).call(this, topic, listener);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, data, listener) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.emitTo || !this.listenTo)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                return _context.abrupt("return", _get$1(_getPrototypeOf(Messenger.prototype), "request", this).call(this, topic, data, listener));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "respond",
    value: function respond(topic, responder) {
      if (!this.emitTo || !this.listenTo) return;

      _get$1(_getPrototypeOf(Messenger.prototype), "respond", this).call(this, topic, responder);
    }
  }, {
    key: "once",
    value: function () {
      var _once = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(topic, listener) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.listenTo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                return _context2.abrupt("return", _get$1(_getPrototypeOf(Messenger.prototype), "once", this).call(this, topic, listener));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function once(_x4, _x5) {
        return _once.apply(this, arguments);
      }

      return once;
    }()
  }, {
    key: "setupPostMessageListener",
    value: function setupPostMessageListener() {
      if (this.listenTo) {
        if (this.postMessageListenerAttached) {
          throw new Error('Post message listener has already been attached');
        }

        this.listenTo.addEventListener('message', this.postMessageListener);
        this.postMessageListenerAttached = true;
      }
    }
  }, {
    key: "removePostmessageListener",
    value: function removePostmessageListener() {
      if (this.listenTo) {
        this.listenTo.removeEventListener('message', this.postMessageListener);
        this.postMessageListenerAttached = false;
      }
    }
  }, {
    key: "postMessageListener",
    value: function postMessageListener(event) {
      try {
        if (event.data) {
          var data = JSON.parse(event.data || '') || {};
          var message = this.createPostMessage(data.channel, data.topic, data.data);
          this.receivePostMessage(message);
        }
      } catch (err) {// throw new Error('Could not handle message, got error: ' + err.toString())
      }
    }
  }, {
    key: "emitMessage",
    value: function emitMessage(topic, payload) {
      try {
        var message = this.createPostMessage(this.channel, topic, payload);
        this.emitPostMessage(message);
      } catch (err) {
        throw new Error('Could not emit message, got error: ' + err.toString());
      }
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(topic, payload) {
      this.notifyListeners(topic, _cloneDeep(payload));
      this.notifyResponders(topic, _cloneDeep(payload));
    }
  }, {
    key: "receivePostMessage",
    value: function receivePostMessage(message) {
      if (message && message.topic === null) {
        return;
      }

      if (message.channel !== this.channel) {
        return;
      }

      this.debug && console.debug('[epik] messenger ' + (this.label || '') + ' receive', _cloneDeep(message));
      this.receiveMessage(message.topic, message.data);
    }
  }, {
    key: "emitPostMessage",
    value: function emitPostMessage(message) {
      if (!this.emitTo) {
        throw new Error('Can not emit, emit target has not been set');
      }

      try {
        this.debug && console.debug('[epik] messenger ' + (this.label || '') + ' emit', _cloneDeep(message));
        this.emitTo.postMessage(_JSON$stringify(message), '*');
      } catch (err) {
        throw new Error('Could not send message, got error: ' + err.toString());
      }
    }
  }, {
    key: "createPostMessage",
    value: function createPostMessage(channel, topic, payload) {
      channel = channel || null;
      topic = topic || null;
      var message = {
        channel: channel,
        topic: topic,
        data: payload
      };
      return message;
    }
  }]);

  return Messenger;
}(Eventer);

function ownKeys$2(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

///////////////////////////////////////////////////////////////////////////////
var EppApiProxy = /*#__PURE__*/function () {
  function EppApiProxy(url, http) {
    _classCallCheck(this, EppApiProxy);

    this.url = void 0;
    this.http = void 0;
    this.url = url;
    this.http = http || axios.create();
  }

  _createClass(EppApiProxy, [{
    key: "fetchTransaction",
    value: function () {
      var _fetchTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _context;

        var eppApiKey, eppTransactionId, _yield$this$sendReque, data;

        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eppApiKey = args.eppApiKey, eppTransactionId = args.eppTransactionId;
                _context2.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: _concatInstanceProperty(_context = "/organisations/".concat(eppApiKey, "/transactions/")).call(_context, eppTransactionId)
                });

              case 3:
                _yield$this$sendReque = _context2.sent;
                data = _yield$this$sendReque.data;
                data = normalizeValues(data);
                return _context2.abrupt("return", data);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchTransaction(_x) {
        return _fetchTransaction.apply(this, arguments);
      }

      return fetchTransaction;
    }()
  }, {
    key: "fetchSubscription",
    value: function () {
      var _fetchSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var _context3;

        var eppApiKey, subscriptionToken, _yield$this$sendReque2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                eppApiKey = args.eppApiKey, subscriptionToken = args.subscriptionToken;
                _context4.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: _concatInstanceProperty(_context3 = "/organisations/".concat(eppApiKey, "/subscriptions/")).call(_context3, subscriptionToken)
                });

              case 3:
                _yield$this$sendReque2 = _context4.sent;
                data = _yield$this$sendReque2.data;
                data = normalizeValues(data);
                return _context4.abrupt("return", data);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchSubscription(_x2) {
        return _fetchSubscription.apply(this, arguments);
      }

      return fetchSubscription;
    }()
  }, {
    key: "fetchCustomer",
    value: function () {
      var _fetchCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args) {
        var _context5;

        var eppApiKey, customerToken, _yield$this$sendReque3, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                eppApiKey = args.eppApiKey, customerToken = args.customerToken;
                _context6.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: _concatInstanceProperty(_context5 = "/organisations/".concat(eppApiKey, "/customers/")).call(_context5, customerToken)
                });

              case 3:
                _yield$this$sendReque3 = _context6.sent;
                data = _yield$this$sendReque3.data;
                data = normalizeValues(data);
                return _context6.abrupt("return", data);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchCustomer(_x3) {
        return _fetchCustomer.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: "cancelSubscription",
    value: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args) {
        var _context7;

        var eppApiKey, subscriptionToken, _yield$this$sendReque4, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                eppApiKey = args.eppApiKey, subscriptionToken = args.subscriptionToken;
                _context8.next = 3;
                return this.sendRequest({
                  method: 'post',
                  url: _concatInstanceProperty(_context7 = "/organisations/".concat(eppApiKey, "/subscriptions/")).call(_context7, subscriptionToken, "/cancel")
                });

              case 3:
                _yield$this$sendReque4 = _context8.sent;
                data = _yield$this$sendReque4.data;
                data = normalizeValues(data);
                return _context8.abrupt("return", data);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee4, this);
      }));

      function cancelSubscription(_x4) {
        return _cancelSubscription.apply(this, arguments);
      }

      return cancelSubscription;
    }()
  }, {
    key: "updateCustomer",
    value: function () {
      var _updateCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args) {
        var _context9;

        var eppApiKey, customerToken, fields, _yield$this$sendReque5, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                eppApiKey = args.eppApiKey, customerToken = args.customerToken, fields = args.fields;
                _context10.next = 3;
                return this.sendRequest({
                  method: 'post',
                  url: _concatInstanceProperty(_context9 = "/organisations/".concat(eppApiKey, "/customers/")).call(_context9, customerToken),
                  data: fields
                });

              case 3:
                _yield$this$sendReque5 = _context10.sent;
                data = _yield$this$sendReque5.data;
                data = normalizeValues(data);
                return _context10.abrupt("return", data);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateCustomer(_x5) {
        return _updateCustomer.apply(this, arguments);
      }

      return updateCustomer;
    }()
  }, {
    key: "fetchReferenceNumber",
    value: function () {
      var _fetchReferenceNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(args) {
        var _context11;

        var eppApiKey, _args$eppMerchantId, eppMerchantId, campaignId, url, _yield$this$sendReque6, data, _normalizeValues, refno;

        return _regeneratorRuntime.wrap(function _callee6$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                eppApiKey = args.eppApiKey, _args$eppMerchantId = args.eppMerchantId, eppMerchantId = _args$eppMerchantId === void 0 ? '' : _args$eppMerchantId, campaignId = args.campaignId;
                url = campaignId ? _concatInstanceProperty(_context11 = "/organisations/".concat(eppApiKey, "/payment-slips/")).call(_context11, campaignId) : "/organisations/".concat(eppApiKey, "/payment-slips");
                _context12.next = 4;
                return this.sendRequest({
                  method: 'get',
                  url: url,
                  params: {
                    merchant_id: eppMerchantId
                  }
                });

              case 4:
                _yield$this$sendReque6 = _context12.sent;
                data = _yield$this$sendReque6.data;
                _normalizeValues = normalizeValues(data), refno = _normalizeValues.refno;
                return _context12.abrupt("return", refno);

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchReferenceNumber(_x6) {
        return _fetchReferenceNumber.apply(this, arguments);
      }

      return fetchReferenceNumber;
    }()
  }, {
    key: "sendRequest",
    value: function sendRequest(config) {
      var url = this.url + config.url;
      return this.http.request(_objectSpread$2(_objectSpread$2({}, config), {}, {
        url: url
      }));
    }
  }]);

  return EppApiProxy;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEppApiProxy = function createEppApiProxy(url) {
  return new EppApiProxy(url);
};

function ownKeys$1(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
///////////////////////////////////////////////////////////////////////////////
var EpmsApiProxy = /*#__PURE__*/function () {
  function EpmsApiProxy(url, http) {
    _classCallCheck(this, EpmsApiProxy);

    this.url = void 0;
    this.http = void 0;
    this.url = url;
    this.http = http || axios.create();
  }

  _createClass(EpmsApiProxy, [{
    key: "fetchPayment",
    value: function () {
      var _fetchPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var epmsPaymentUuid, _yield$this$sendReque, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                epmsPaymentUuid = args.epmsPaymentUuid;
                _context.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/payments/".concat(epmsPaymentUuid)
                });

              case 3:
                _yield$this$sendReque = _context.sent;
                data = _yield$this$sendReque.data;
                return _context.abrupt("return", data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchPayment(_x) {
        return _fetchPayment.apply(this, arguments);
      }

      return fetchPayment;
    }()
  }, {
    key: "fetchSubscription",
    value: function () {
      var _fetchSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var epmsSubscriptionUuid, _yield$this$sendReque2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid;
                _context2.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/subscriptions/".concat(epmsSubscriptionUuid)
                });

              case 3:
                _yield$this$sendReque2 = _context2.sent;
                data = _yield$this$sendReque2.data;
                return _context2.abrupt("return", data);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchSubscription(_x2) {
        return _fetchSubscription.apply(this, arguments);
      }

      return fetchSubscription;
    }()
  }, {
    key: "fetchPaymentSource",
    value: function () {
      var _fetchPaymentSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args) {
        var epmsPaymentSourceUuid, _yield$this$sendReque3, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                epmsPaymentSourceUuid = args.epmsPaymentSourceUuid;
                _context3.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/payment-sources/".concat(epmsPaymentSourceUuid)
                });

              case 3:
                _yield$this$sendReque3 = _context3.sent;
                data = _yield$this$sendReque3.data;
                return _context3.abrupt("return", data);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchPaymentSource(_x3) {
        return _fetchPaymentSource.apply(this, arguments);
      }

      return fetchPaymentSource;
    }()
  }, {
    key: "fetchPaymentBySubscriptionUuid",
    value: function () {
      var _fetchPaymentBySubscriptionUuid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args) {
        var epmsSubscriptionUuid, _yield$this$sendReque4, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid;
                _context4.next = 3;
                return this.sendRequest({
                  method: 'get',
                  url: "/epms/payments/get-by-subscription-uuid/".concat(epmsSubscriptionUuid)
                });

              case 3:
                _yield$this$sendReque4 = _context4.sent;
                data = _yield$this$sendReque4.data;
                return _context4.abrupt("return", data);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchPaymentBySubscriptionUuid(_x4) {
        return _fetchPaymentBySubscriptionUuid.apply(this, arguments);
      }

      return fetchPaymentBySubscriptionUuid;
    }()
  }, {
    key: "cancelSubscription",
    value: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(args) {
        var epmsSubscriptionUuid;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid;
                _context5.next = 3;
                return this.sendRequest({
                  method: 'post',
                  url: "/epms/subscriptions/".concat(epmsSubscriptionUuid, "/cancel")
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function cancelSubscription(_x5) {
        return _cancelSubscription.apply(this, arguments);
      }

      return cancelSubscription;
    }()
  }, {
    key: "updateSubscription",
    value: function () {
      var _updateSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(args) {
        var epmsSubscriptionUuid, update;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                epmsSubscriptionUuid = args.epmsSubscriptionUuid, update = args.update;
                _context6.next = 3;
                return this.sendRequest({
                  method: 'patch',
                  url: "/epms/subscriptions/".concat(epmsSubscriptionUuid),
                  data: update
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function updateSubscription(_x6) {
        return _updateSubscription.apply(this, arguments);
      }

      return updateSubscription;
    }()
  }, {
    key: "sendRequest",
    value: function sendRequest(config) {
      var url = this.url + config.url;
      return this.http.request(_objectSpread$1(_objectSpread$1({}, config), {}, {
        url: url
      }));
    }
  }]);

  return EpmsApiProxy;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEpmsApiProxy = function createEpmsApiProxy(url) {
  return new EpmsApiProxy(url);
};

///////////////////////////////////////////////////////////////////////////////
var createEpikConfig = function createEpikConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  config = _cloneDeep(config) || {};
  var eppApiKeyDefault = "1234567890";
  config.debug = findDefinedValue(config.debug, false);
  config.eppApiKey = findDefinedValue(config.eppApiKey, eppApiKeyDefault);
  config.eppEnv = findDefinedValue(config.eppEnv, 'prod');
  config.epmsEnv = findDefinedValue(config.epmsEnv, 'prod'); /////////////////////////////////////////////////////////////////////////////

  var eppApiUrlStage = "https://api.stage.raisenow.net";
  var eppApiUrlProd = "https://payment.raisenow.com";
  var eppApiUrl = config.eppEnv === 'stage' ? eppApiUrlStage : eppApiUrlProd;
  config.eppApiUrl = findDefinedValue(config.eppApiUrl, eppApiUrl); /////////////////////////////////////////////////////////////////////////////

  var epmsApiUrlStage = "https://api.stage.mesos.raisenow.net";
  var epmsApiUrlProd = "https://api.raisenow.io";
  var epmsApiUrl = config.epmsEnv === 'stage' ? epmsApiUrlStage : epmsApiUrlProd;
  config.epmsApiUrl = findDefinedValue(config.epmsApiUrl, epmsApiUrl); /////////////////////////////////////////////////////////////////////////////

  var eppProxyUrlStage = "https://widget-api.stage.mesos.raisenow.net";
  var eppProxyUrlProd = "https://widget-api.raisenow.com";
  var eppProxyUrl = config.eppEnv === 'stage' ? eppProxyUrlStage : eppProxyUrlProd;
  config.eppProxyUrl = findDefinedValue(config.eppProxyUrl, eppProxyUrl); /////////////////////////////////////////////////////////////////////////////

  var epmsProxyUrlStage = "https://widget-api.stage.mesos.raisenow.net";
  var epmsProxyUrlProd = "https://widget-api.raisenow.com";
  var epmsProxyUrl = config.epmsEnv === 'stage' ? epmsProxyUrlStage : epmsProxyUrlProd;
  config.epmsProxyUrl = findDefinedValue(config.epmsProxyUrl, epmsProxyUrl); /////////////////////////////////////////////////////////////////////////////

  var creditCardIframeUrlStage = "https://api.stage.raisenow.net/cc-iframe/latest/index.html";
  var creditCardIframeUrlProd = "https://payment.raisenow.com/cc-iframe/latest/index.html";
  var creditCardIframeUrl = config.eppEnv === 'stage' ? creditCardIframeUrlStage : creditCardIframeUrlProd;
  config.creditCardIframeUrl = findDefinedValue(config.creditCardIframeUrl, creditCardIframeUrl); /////////////////////////////////////////////////////////////////////////////

  config.testMode = findDefinedValue(config.testMode, true);
  config.language = findDefinedValue(config.language, 'en');
  config.reqtype = findDefinedValue(config.reqtype, 'CAA');
  config.furtherRnwInteraction = findDefinedValue(config.furtherRnwInteraction, false);
  config.returnParameters = findDefinedValue(config.returnParameters, false);
  config.creditCardIframeTargetSelector = config.creditCardIframeTargetSelector || null;
  config.transactionStatusPollForceRequestsCount = findDefinedValue(config.transactionStatusPollForceRequestsCount, 5);
  config.transactionStatusPollInterval = findDefinedValue(config.transactionStatusPollInterval, 1000);
  config.skipCvv = findDefinedValue(config.skipCvv, false);
  return config;
};

///////////////////////////////////////////////////////////////////////////////
var Payment = /*#__PURE__*/function () {
  function Payment(epik) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Payment);

    this.epik = epik;
    this.config = config;
    this.creditCardIframe = void 0;
  }

  _createClass(Payment, [{
    key: "update",
    value: function update(config) {
      this.config = _merge(this.config, config);
    }
  }, {
    key: "replace",
    value: function replace(config) {
      this.config = _cloneDeep(config);
    }
  }, {
    key: "read",
    value: function read() {
      return _cloneDeep(this.config);
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.epik.sendPayment(this.config, this.creditCardIframe));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send() {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "markAllFieldsAsTouched",
    value: function markAllFieldsAsTouched() {
      if (this.creditCardIframe) {
        var messenger = this.creditCardIframe.messenger;
        messenger.emit(CreditCardIframeMessageType.MARK_ALL_FIELDS_AS_TOUCHED);
      }
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.epik.validatePayment(this.config, this.creditCardIframe));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "showCreditCardIframe",
    value: function () {
      var _showCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(targetSelector, url) {
        var _this$epik$config, creditCardIframeUrl, creditCardIframeTargetSelector, flow, iframeUrl;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.creditCardIframe) {
                  this.hideCreditCardIframe();
                }

                _this$epik$config = this.epik.config, creditCardIframeUrl = _this$epik$config.creditCardIframeUrl, creditCardIframeTargetSelector = _this$epik$config.creditCardIframeTargetSelector;
                flow = this.config.flow;
                targetSelector = findDefinedValue(targetSelector, creditCardIframeTargetSelector);
                iframeUrl = findDefinedValue(url, creditCardIframeUrl);
                _context3.next = 7;
                return this.epik.createCreditCardIframe(targetSelector, iframeUrl, flow);

              case 7:
                this.creditCardIframe = _context3.sent;
                return _context3.abrupt("return", this.creditCardIframe);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function showCreditCardIframe(_x, _x2) {
        return _showCreditCardIframe.apply(this, arguments);
      }

      return showCreditCardIframe;
    }()
  }, {
    key: "hideCreditCardIframe",
    value: function hideCreditCardIframe() {
      if (this.creditCardIframe) {
        var _this$creditCardIfram = this.creditCardIframe,
            iframe = _this$creditCardIfram.iframe,
            messenger = _this$creditCardIfram.messenger;
        messenger.removePostmessageListener();
        iframe.parentNode.removeChild(iframe);
        this.creditCardIframe = null;
      }
    }
  }]);

  return Payment;
}(); ///////////////////////////////////////////////////////////////////////////////

var createPayment = function createPayment(epik, payment) {
  return new Payment(epik, payment);
};

var PaymentPreparator = /*#__PURE__*/function () {
  function PaymentPreparator() {
    _classCallCheck(this, PaymentPreparator);
  }

  _createClass(PaymentPreparator, [{
    key: "prepareMetadata",
    value: function prepareMetadata(payment, epik) {
      var relevantFields = ['flow', 'payment_method', 'currency', 'amount', 'test_mode', 'mobile_mode', 'language', 'reqtype', 'further_rnw_interaction', 'return_parameters', 'subscription_token', 'epms_subscription_uuid', 'recaptcha', 'success_url', 'error_url', 'cancel_url', 'country_code'];
      payment.flow = findDefinedValue(payment.flow, PaymentFlow.EPP);

      if (payment.flow === PaymentFlow.EPMS) {
        relevantFields.push('profile', 'return_url', 'create_supporter', 'supporter', 'raisenow', 'custom_parameters', 'payment_information');
      }

      if (payment.payment_provider == PaymentProvider.INGCOLLECT) {
        payment.country_code = payment.stored_customer_country;
      }

      payment.test_mode = findDefinedValue(payment.test_mode, epik.config.testMode, true);
      payment.mobile_mode = false;
      payment.language = findDefinedValue(payment.language, epik.config.language);
      payment.reqtype = findDefinedValue(payment.reqtype, epik.config.reqtype);
      payment.further_rnw_interaction = findDefinedValue(payment.further_rnw_interaction, epik.config.furtherRnwInteraction) ? 'enabled' : 'disabled';
      payment.return_parameters = findDefinedValue(payment.return_parameters, epik.config.returnParameters, false); // for epp

      payment.success_url = prepareReturnUrl(findDefinedValue(epik.config.successUrl, epik.window.location.href));
      payment.error_url = prepareReturnUrl(findDefinedValue(epik.config.errorUrl, epik.window.location.href));
      payment.cancel_url = prepareReturnUrl(findDefinedValue(epik.config.cancelUrl, epik.window.location.href)); // for epms

      payment.return_url = prepareReturnUrl(findDefinedValue(payment.return_url, epik.window.location.href));
      var params = {};

      if (payment.subscription_token || payment.epms_subscription_uuid) {
        params[EpikQueryParam.VIEW] = 'subscription_payment_method_update_result';
      } else {
        params[EpikQueryParam.VIEW] = 'payment_result';
      }

      payment.success_url = updateUrlParams(payment.success_url, params);
      payment.error_url = updateUrlParams(payment.error_url, params);
      payment.cancel_url = updateUrlParams(payment.cancel_url, params);
      payment.return_url = updateUrlParams(payment.return_url, params);
      return relevantFields;
    }
  }, {
    key: "prepareHmac",
    value: function prepareHmac(payment) {
      var relevantFields = [];

      if (payment.hmac) {
        relevantFields.push('hmac');
      }

      return relevantFields;
    }
  }, {
    key: "prepareRecurring",
    value: function prepareRecurring(payment, epik) {
      var relevantFields = [];
      var isRecurring = false;
      var isPseudoRecurring = false;

      if (payment.recurring || payment.stored_pseudo_recurring) {
        isRecurring = RecurringPaymentMethods.indexOf(payment.payment_method) !== -1;
        isPseudoRecurring = PseudoRecurringPaymentMethods.indexOf(payment.payment_method) !== -1;
      }

      if (isRecurring) {
        relevantFields.push('recurring');
        payment.recurring = true;
      }

      if (isPseudoRecurring) {
        relevantFields.push('stored_pseudo_recurring');
        payment.stored_pseudo_recurring = true;
      }

      if (isRecurring || isPseudoRecurring) {
        relevantFields.push('recurring_interval', 'stored_rnw_recurring_interval_name', 'stored_customer_email', 'immediate_execution');

        if (payment.recurring_interval) {
          payment.recurring_interval = epik.cronHelper.getRecurringIntervalExpression(payment.recurring_interval);
        }

        if (!_isBoolean(payment.immediate_execution)) {
          payment.immediate_execution = true;
        }
      }

      return relevantFields;
    }
  }, {
    key: "prepareCreditCard",
    value: function () {
      var _prepareCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payment, epik, creditCardIframe) {
        var relevantFields, skipCvv, hasCardHolderName, hasFirstAndLastName, hasCardNumber, hasExpirationYear;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                relevantFields = [];

                if (!isCreditCardPaymentMethod(payment.payment_method)) {
                  _context.next = 15;
                  break;
                }

                relevantFields.push('card_holder_name', 'payment_provider', 'create_payment_source');
                skipCvv = !!epik.config.skipCvv;
                hasCardHolderName = !!payment.card_holder_name;
                hasFirstAndLastName = !!payment.stored_customer_firstname && !!payment.stored_customer_lastname;

                if (!hasCardHolderName && hasFirstAndLastName) {
                  payment.card_holder_name = payment.stored_customer_firstname + ' ' + payment.stored_customer_lastname;
                }

                if (!creditCardIframe) {
                  _context.next = 12;
                  break;
                }

                relevantFields.push('card_token');
                _context.next = 11;
                return epik.acquireCreditCardTokenFromIframe(creditCardIframe);

              case 11:
                payment.card_token = _context.sent;

              case 12:
                if (!creditCardIframe) {
                  relevantFields.push('cardno', 'expm', 'expy');

                  if (!skipCvv) {
                    relevantFields.push('cvv');
                  }

                  hasCardNumber = !!payment.cardno;
                  hasExpirationYear = !!payment.expy;

                  if (hasCardNumber) {
                    payment.cardno = payment.cardno.replace(/[A-z\s-]+/g, '');
                  }

                  if (hasExpirationYear) {
                    payment.expy = prepareExpirationYear(payment.expy, payment.flow);
                  }
                }

                _context.next = 15;
                return this.autodetectAndSetCreditCardPaymentMethod(payment, epik, creditCardIframe);

              case 15:
                return _context.abrupt("return", relevantFields);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepareCreditCard(_x, _x2, _x3) {
        return _prepareCreditCard.apply(this, arguments);
      }

      return prepareCreditCard;
    }()
  }, {
    key: "autodetectAndSetCreditCardPaymentMethod",
    value: function () {
      var _autodetectAndSetCreditCardPaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payment, epik, creditCardIframe) {
        var isStripe, isEpp, paymentMethod;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isStripe = payment.payment_provider === PaymentProvider.STRIPE;
                isEpp = payment.flow === PaymentFlow.EPP;

                if (!(isStripe && isEpp)) {
                  _context2.next = 5;
                  break;
                }

                payment.payment_method = PaymentMethod.STRIPE;
                return _context2.abrupt("return");

              case 5:
                if (!creditCardIframe) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 8;
                return epik.acquireCreditCardTypeFromIframe(creditCardIframe);

              case 8:
                paymentMethod = _context2.sent;

              case 9:
                if (!creditCardIframe) {
                  if (!!payment.cardno) {
                    paymentMethod = getCreditCardType(payment.cardno, payment.flow);
                  }
                }

                if (!paymentMethod) {
                  paymentMethod = FallbackCreditCardPaymentMethod;
                }

                payment.payment_method = paymentMethod;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function autodetectAndSetCreditCardPaymentMethod(_x4, _x5, _x6) {
        return _autodetectAndSetCreditCardPaymentMethod.apply(this, arguments);
      }

      return autodetectAndSetCreditCardPaymentMethod;
    }()
  }, {
    key: "preparePayu",
    value: function preparePayu(payment) {
      var relevantFields = [];
      var isPayu = isCreditCardPaymentMethod(payment.payment_method) && payment.payment_provider === PaymentProvider.PAYU;

      if (isPayu) {
        relevantFields.push('statement_descriptor');
      }

      return relevantFields;
    }
  }, {
    key: "prepareDirectDebit",
    value: function prepareDirectDebit(payment) {
      var relevantFields = [];
      var isDirectDebit = payment.payment_method === PaymentMethod.DIRECT_DEBIT;

      if (isDirectDebit) {
        relevantFields.push('iban', 'bank_name', 'bank_city', 'bank_zip_code', 'form_template');
      }

      return relevantFields;
    }
  }, {
    key: "prepareElv",
    value: function prepareElv(payment) {
      var relevantFields = [];
      var isElv = payment.payment_method === PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN;

      if (isElv) {
        relevantFields.push('bankiban');
      }

      return relevantFields;
    }
  }, {
    key: "prepareSepaOne",
    value: function prepareSepaOne(payment) {
      var relevantFields = [];
      var isSepaOne = payment.payment_method === PaymentMethod.SEPA_ONE;

      if (isSepaOne) {
        relevantFields.push('bankiban', 'bankbic');
      }

      return relevantFields;
    }
  }, {
    key: "preparePaymentSlip",
    value: function () {
      var _preparePaymentSlip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payment, epik) {
        var relevantFields, isES, isEZS, hasPayerLine1, hasPayerLine2, hasPayerLine3, hasPayerLine4, hasRefno, hasStoredCustomerFirstname, hasStoredCustomerLastname, hasStoredCustomerStreet, hasStoredCustomerStreetNumber, hasStoredCustomerStreetZipCode, hasStoredCustomerStreetCity, hasStoredCustomerCountry;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                relevantFields = [];
                isES = payment.payment_method === PaymentMethod.PAYMENT_SLIP;
                isEZS = payment.payment_method === PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER;
                hasPayerLine1 = !!payment.payer_line1;
                hasPayerLine2 = !!payment.payer_line2;
                hasPayerLine3 = !!payment.payer_line3;
                hasPayerLine4 = !!payment.payer_line4;
                hasRefno = !!payment.refno;
                hasStoredCustomerFirstname = !!payment.stored_customer_firstname;
                hasStoredCustomerLastname = !!payment.stored_customer_lastname;
                hasStoredCustomerStreet = !!payment.stored_customer_street;
                hasStoredCustomerStreetNumber = !!payment.stored_customer_street_number;
                hasStoredCustomerStreetZipCode = !!payment.stored_customer_zip_code;
                hasStoredCustomerStreetCity = !!payment.stored_customer_city;
                hasStoredCustomerCountry = !!payment.stored_customer_country;

                if (isES) {
                  relevantFields.push('stored_es_ordered', 'es_message');
                }

                if (isEZS) {
                  relevantFields.push('stored_ezs_ordered', 'refno');
                }

                if (isES || isEZS) {
                  relevantFields.push('payer_line1', 'payer_line2', 'payer_line3', 'payer_line4');
                }

                if ((isES || isEZS) && !hasPayerLine1 && hasStoredCustomerFirstname && hasStoredCustomerLastname) {
                  payment.payer_line1 = payment.stored_customer_firstname + ' ' + payment.stored_customer_lastname;
                }

                if ((isES || isEZS) && !hasPayerLine2 && hasStoredCustomerStreet) {
                  payment.payer_line2 = payment.stored_customer_street; // stored_customer_street_number is optional

                  if (hasStoredCustomerStreetNumber) {
                    payment.payer_line2 += ' ' + payment.stored_customer_street_number;
                  }
                }

                if ((isES || isEZS) && !hasPayerLine3 && hasStoredCustomerStreetZipCode && hasStoredCustomerStreetCity) {
                  payment.payer_line3 = payment.stored_customer_zip_code + ' ' + payment.stored_customer_city;
                }

                if ((isES || isEZS) && !hasPayerLine4 && hasStoredCustomerCountry) {
                  payment.payer_line4 = payment.stored_customer_country;
                }

                if (!(isEZS && !hasRefno)) {
                  _context3.next = 32;
                  break;
                }

                epik.config.debug && console.debug('[epik] fetching refno');
                _context3.prev = 24;
                _context3.next = 27;
                return epik.fetchReferenceNumber(payment.stored_campaign_id);

              case 27:
                payment.refno = _context3.sent;
                _context3.next = 32;
                break;

              case 30:
                _context3.prev = 30;
                _context3.t0 = _context3["catch"](24);

              case 32:
                return _context3.abrupt("return", relevantFields);

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[24, 30]]);
      }));

      function preparePaymentSlip(_x7, _x8) {
        return _preparePaymentSlip.apply(this, arguments);
      }

      return preparePaymentSlip;
    }()
  }, {
    key: "prepareSms",
    value: function prepareSms(payment) {
      var relevantFields = [];
      var isSms = payment.payment_method === PaymentMethod.SMS;
      var hasMsisdn = !!payment.msisdn;

      if (isSms) {
        relevantFields.push('msisdn');

        if (hasMsisdn) {
          payment.msisdn = ('' + payment.msisdn).replace(/\s/g, '');
        } else {
          payment.msisdn = '';
        }
      }

      return relevantFields;
    }
  }, {
    key: "prepareCustomFields",
    value: function prepareCustomFields(payment) {
      // following fields are handled separately so should be ignored here
      var ignore = ['stored_pseudo_recurring', 'stored_payment_slip_delivery_type', 'stored_es_ordered', 'stored_ezs_ordered'];
      return _filter(_keys(payment), function (k) {
        return _startsWith(k, 'stored_') && ignore.indexOf(k) === -1;
      });
    }
  }]);

  return PaymentPreparator;
}(); ///////////////////////////////////////////////////////////////////////////////

var createPaymentPreparator = function createPaymentPreparator() {
  return new PaymentPreparator();
};

var validateMinLength = function validateMinLength(input, length) {
  return input && input.length >= length;
};
var validateMaxLength = function validateMaxLength(input, length) {
  return input && input.length <= length;
};
var validateLengthBetween = function validateLengthBetween(input, minLength, maxLength) {
  return validateMinLength(input, minLength) && validateMaxLength(input, maxLength);
};
var validateNumerical = function validateNumerical(input) {
  return /^[.\d]+$/.test(input);
};
var validateNumberBetween = function validateNumberBetween(input, min, max) {
  var number = parseFloat(input);
  return number >= min && number <= max;
};
var validateInRange = function validateInRange(input, range) {
  return range.indexOf(input) !== -1;
};

var validateCreditCardNumber = function validateCreditCardNumber(cardNumber, paymentFlow) {
  return validateNumerical(cardNumber) && validateCreditCardLength(cardNumber, paymentFlow) && validateCreditCardLuhn(cardNumber);
};
var validateCreditCardLength = function validateCreditCardLength(cardNumber, paymentFlow) {
  var type = getCreditCardType(cardNumber, paymentFlow);

  if (paymentFlow === PaymentFlow.EPMS) {
    if (type === PaymentMethod.NARANJA) {
      return _includes([16], cardNumber.length);
    }

    if (type === PaymentMethod.TARJETA) {
      return _includes([13, 16], cardNumber.length);
    }

    if (type === PaymentMethod.CABAL) {
      return _includes([16], cardNumber.length);
    }

    if (type === PaymentMethod.ARGENCARD) {
      return _includes([16], cardNumber.length);
    }

    if (type === PaymentMethod.CENCOSUD) {
      return _includes([16], cardNumber.length);
    }

    if (type === PaymentMethod.HIPERCARD) {
      return _includes([16], cardNumber.length); // TODO: clarify correct length for hipercard
    }

    if (type === PaymentMethod.CODENSA) {
      return _includes([16], cardNumber.length);
    }

    if (type === PaymentMethod.CREDENCIAL) {
      return _includes([16], cardNumber.length);
    }
  }

  if (type === PaymentMethod.AMERICAN_EXPRESS) {
    return _includes([15], cardNumber.length);
  }

  if (type === PaymentMethod.VISA) {
    return _includes([13, 16, 19], cardNumber.length);
  }

  if (type === PaymentMethod.MASTER_CARD) {
    return _includes([16], cardNumber.length);
  }

  if (type === PaymentMethod.DISCOVERY) {
    return _includes([16, 17, 18, 19], cardNumber.length);
  }

  if (type === PaymentMethod.DINERS_CLUB) {
    return _includes([14, 15, 16, 17, 18, 19], cardNumber.length);
  }

  if (type === PaymentMethod.JAPANESE_CREDIT_BUREAU) {
    return _includes([16, 17, 18, 19], cardNumber.length);
  }

  if (type === PaymentMethod.MAESTRO) {
    return _includes([12, 13, 14, 15, 16, 17, 18, 19], cardNumber.length);
  }

  return false;
};
var validateCreditCardLuhn = function validateCreditCardLuhn(cardNumber) {
  var s = 0;
  var doubleDigit = false;

  for (var i = cardNumber.length - 1; i >= 0; i--) {
    var digit = +cardNumber[i];

    if (doubleDigit) {
      digit *= 2;

      if (digit > 9) {
        digit -= 9;
      }
    }

    s += digit;
    doubleDigit = !doubleDigit;
  }

  return s % 10 === 0;
};
var validateCreditCardCvv = function validateCreditCardCvv(input) {
  return validateNumerical(input) && validateLengthBetween(input, 3, 4);
};
var validateCreditCardExpirationMonth = function validateCreditCardExpirationMonth(input) {
  return validateNumberBetween(input, 1, 12);
};
var validateCreditCardExpirationYear = function validateCreditCardExpirationYear(input) {
  var expy = parseInt(input);
  expy = expy < 100 ? expy + 2000 : expy;
  var currentYear = new Date().getFullYear();
  return validateNumberBetween(expy, currentYear, currentYear + 50);
};

// https://en.wikipedia.org/wiki/International_Bank_Account_Number
var IBAN_FORMATS = {
  // for items below:
  //    kk = represent the IBAN checksum
  //    b = National bank code
  //    s = Branch code
  //    x = National check digit
  //    c = Account number
  //    a - Balance account number
  //    t = Account type
  //    n = Owner account number
  //    m = Currency
  //    i = holder's identification number
  //    0 = Zeroes
  'Albania': 'ALkk bbbs sssx cccc cccc cccc cccc',
  'Andorra': 'ADkk bbbb ssss cccc cccc cccc',
  'Austria': 'ATkk bbbb bccc cccc cccc',
  'Azerbaijan': 'AZkk bbbb cccc cccc cccc cccc cccc',
  'Bahrain': 'BHkk bbbb cccc cccc cccc cc',
  'Belarus': 'BYkk bbbb aaaa cccc cccc cccc cccc',
  'Belgium': 'BEkk bbbc cccc ccxx',
  'Bosnia and Herzegovina': 'BAkk bbbs sscc cccc ccxx',
  'Brazil': 'BRkk bbbb bbbb ssss sccc cccc ccct n',
  'Bulgaria': 'BGkk bbbb ssss ttcc cccc cc',
  'Costa Rica': 'CRkk 0bbb cccc cccc cccc cc',
  'Croatia': 'HRkk bbbb bbbc cccc cccc c',
  'Cyprus': 'CYkk bbbs ssss cccc cccc cccc cccc',
  'Czech Republic': 'CZkk bbbb ssss sscc cccc cccc',
  'Denmark': 'DKkk bbbb cccc cccc cc',
  'Dominican Republic': 'DOkk bbbb cccc cccc cccc cccc cccc',
  'East Timor': 'TLkk bbbc cccc cccc cccc cxx',
  'Estonia': 'EEkk bbss cccc cccc cccx',
  'Faroe Islands': 'FOkk bbbb cccc cccc cx',
  'Finland': 'FIkk bbbb bbcc cccc cx',
  'France': 'FRkk bbbb bsss sscc cccc cccc cxx',
  'Georgia': 'GEkk bbcc cccc cccc cccc cc',
  'Germany': 'DEkk bbbb bbbb cccc cccc cc',
  'Gibraltar': 'GIkk bbbb cccc cccc cccc ccc',
  'Greece': 'GRkk bbbs sssc cccc cccc cccc ccc',
  'Greenland': 'GLkk bbbb cccc cccc cc',
  'Guatemala': 'GTkk bbbb mmtt cccc cccc cccc cccc',
  'Hungary': 'HUkk bbbs sssx cccc cccc cccc cccx',
  'Iceland': 'ISkk bbbb sscc cccc iiii iiii ii',
  'Ireland': 'IEkk aaaa bbbb bbcc cccc cc',
  'Israel': 'ILkk bbbn nncc cccc cccc ccc',
  'Italy': 'ITkk xbbb bbss sssc cccc cccc ccc',
  'Jordan': 'JOkk bbbb ssss cccc cccc cccc cccc cc',
  'Kazakhstan': 'KZkk bbbc cccc cccc cccc',
  'Kosovo': 'XKkk bbbb cccc cccc cccc',
  'Kuwait': 'KWkk bbbb cccc cccc cccc cccc cccc cc',
  'Latvia': 'LVkk bbbb cccc cccc cccc c',
  'Lebanon': 'LBkk bbbb cccc cccc cccc cccc cccc',
  'Liechtenstein': 'LIkk bbbb bccc cccc cccc c',
  'Lithuania': 'LTkk bbbb bccc cccc cccc',
  'Luxembourg': 'LUkk bbbc cccc cccc cccc',
  'Macedonia': 'MKkk bbbc cccc cccc cxx',
  'Malta': 'MTkk bbbb ssss sccc cccc cccc cccc ccc',
  'Mauritania': 'MRkk bbbb bsss sscc cccc cccc cxx',
  'Mauritius': 'MUkk bbbb bbss cccc cccc cccc 000m mm',
  'Monaco': 'MCkk bbbb bsss sscc cccc cccc cxx',
  'Moldova': 'MDkk bbcc cccc cccc cccc cccc',
  'Montenegro': 'MEkk bbbc cccc cccc cccc xx',
  'Netherlands': 'NLkk bbbb cccc cccc cc',
  'Norway': 'NOkk bbbb cccc ccx',
  'Pakistan': 'PKkk bbbb cccc cccc cccc cccc',
  'Palestinian territories': 'PSkk bbbb xxxx xxxx xccc cccc cccc c',
  'Poland': 'PLkk bbbs sssx cccc cccc cccc cccc',
  'Portugal': 'PTkk bbbb ssss cccc cccc cccx x',
  'Qatar': 'QAkk bbbb cccc cccc cccc cccc cccc c',
  'Romania': 'ROkk bbbb cccc cccc cccc cccc',
  'San Marino': 'SMkk xbbb bbss sssc cccc cccc ccc',
  'Saudi Arabia': 'SAkk bbcc cccc cccc cccc cccc',
  'Serbia': 'RSkk bbbc cccc cccc cccc xx',
  'Slovakia': 'SKkk bbbb ssss sscc cccc cccc',
  'Slovenia': 'SIkk bbss sccc cccc cxx',
  'Spain': 'ESkk bbbb ssss xxcc cccc cccc',
  'Sweden': 'SEkk bbbc cccc cccc cccc cccc',
  'Switzerland': 'CHkk bbbb bccc cccc cccc c',
  'Tunisia': 'TNkk bbss sccc cccc cccc cccc',
  'Turkey': 'TRkk bbbb bxcc cccc cccc cccc cc',
  'United Arab Emirates': 'AEkk bbbc cccc cccc cccc ccc',
  'United Kingdom': 'GBkk bbbb ssss sscc cccc cc',
  'Virgin Islands, British': 'VGkk bbbb cccc cccc cccc cccc',
  // for items below:
  //    kk = represent the IBAN checksum
  //    a = represents an alphabetic character
  //    n = represents a numeric character
  //    b = represents a bank code character
  //    c = represents an account digit.
  //    0 = represents a "0" character
  'Algeria': 'DZkk nnnn nnnn nnnn nnnn nnnn',
  'Angola': 'AOkk nnnn nnnn nnnn nnnn nnnn n',
  'Benin': 'BJkk annn nnnn nnnn nnnn nnnn nnnn',
  'Burkina Faso': 'BFkk nnnn nnnn nnnn nnnn nnnn nnnn',
  'Burundi': 'BIkk nnnn nnnn nnnn',
  'Cameroon': 'CMkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Cape Verde': 'CVkk nnnn nnnn nnnn nnnn nnnn n',
  'Iran': 'IRkk 0bb0 nnnn nnnn nnnn nnnn nn',
  'Ivory Coast': 'CIkk annn nnnn nnnn nnnn nnnn nnnn',
  'Madagascar': 'MGkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Mali': 'MLkk annn nnnn nnnn nnnn nnnn nnnn',
  'Mozambique': 'MZkk nnnn nnnn nnnn nnnn nnnn n',
  'Senegal': 'SNkk annn nnnn nnnn nnnn nnnn nnnn',
  'Ukraine': 'UAkk bbbb bbcc cccc cccc cccc cccc c',
  'Comoros': 'KMkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Chad': 'TDkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Congo': 'CGkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Egypt': 'EGkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Gabon': 'GAkk nnnn nnnn nnnn nnnn nnnn nnn',
  'Honduras': 'HNkk aaaa nnnn nnnn nnnn nnnn nnnn',
  'Morocco': 'MAkk nnnn nnnn nnnn nnnn nnnn nnnn',
  'Nicaragua': 'NIkk aaaa nnnn nnnn nnnn nnnn nnnn nnnn',
  'Niger': 'NEkk aann nnnn nnnn nnnn nnnn nnnn',
  'Togo': 'TGkk aann nnnn nnnn nnnn nnnn nnnn'
};

var sanitizeIBAN = function sanitizeIBAN(iban) {
  return (iban || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
};

var getCountryCodeFromIBAN = function getCountryCodeFromIBAN(iban) {
  return (iban || '').substr(0, 2);
};

var getChecksumFromIBAN = function getChecksumFromIBAN(iban) {
  return (iban || '').substr(2, 2);
};

var getAccountNumberFromIBAN = function getAccountNumberFromIBAN(iban) {
  return (iban || '').substr(4);
};

var findFormatForIBAN = function findFormatForIBAN(iban) {
  var countryCode = getCountryCodeFromIBAN(iban);

  for (var countryName in IBAN_FORMATS) {
    var format = IBAN_FORMATS[countryName];

    if (getCountryCodeFromIBAN(format) === countryCode) {
      return IBAN_FORMATS[countryName];
    }
  }

  return null;
};

var checkIBANLength = function checkIBANLength(iban) {
  var ibanFormat = sanitizeIBAN(findFormatForIBAN(iban));
  return iban && ibanFormat && iban.length === ibanFormat.length;
};

var checkIBANChecksum = function checkIBANChecksum(iban) {
  var ibanCountryCode = getCountryCodeFromIBAN(iban);
  var ibanChecksum = getChecksumFromIBAN(iban);
  var ibanNumber = getAccountNumberFromIBAN(iban);
  var reversedIban = ibanNumber + ibanCountryCode + ibanChecksum;
  var ibanInteger = reversedIban.replace(/[A-Z]/g, function (_char) {
    return (_char.charCodeAt(0) - 55).toString();
  });
  var ibanWithoutChecksum = ibanInteger.substr(2);
  var checksum = ibanInteger.substr(0, 2);

  for (var i = 0; i < ibanWithoutChecksum.length; i += 7) {
    var fragment = checksum + ibanWithoutChecksum.substring(i, i + 7);
    checksum = (parseInt(fragment, 10) % 97).toString();
  }

  return checksum === '1';
};

var validateIBAN = function validateIBAN(input) {
  var iban = sanitizeIBAN(input);
  return checkIBANLength(iban) && checkIBANChecksum(iban);
};

var PaymentError = {
  SUCCESS_URL_MISSING: {
    code: 'success_url_missing',
    message: 'Missing success url'
  },
  ERROR_URL_MISSING: {
    code: 'error_url_missing',
    message: 'Missing error url'
  },
  CANCEL_URL_MISSING: {
    code: 'cancel_url_missing',
    message: 'Missing cancel url'
  },
  TEST_MODE_MISSING: {
    code: 'test_mode_missing',
    message: 'Missing test mode setting'
  },
  TEST_MODE_INVALID: {
    code: 'test_mode_invalid',
    message: 'Invalid value'
  },
  LANGUAGE_MISSING: {
    code: 'language_missing',
    message: 'Missing language setting'
  },
  REQTYPE_MISSING: {
    code: 'reqtype_missing',
    message: 'Missing reqtype setting'
  },
  REQTYPE_INVALID: {
    code: 'reqtype_invalid',
    message: 'Invalid value'
  },
  FURTHER_RNW_INTERACTION_MISSING: {
    code: 'further_rnw_interaction_missing',
    message: 'Missing further interaction setting'
  },
  FURTHER_RNW_INTERACTION_INVALID: {
    code: 'further_rnw_interaction_invalid',
    message: 'Invalid value'
  },
  PAYMENT_METHOD_MISSING: {
    code: 'payment_method_missing',
    message: 'Payment method missing'
  },
  PAYMENT_METHOD_INVALID: {
    code: 'payment_method_invalid',
    message: 'Payment method is not supported'
  },
  PAYMENT_PROVIDER_INVALID: {
    code: 'payment_provider_invalid',
    message: 'Payment provider is not supported'
  },
  RECURRING_INTERVAL_MISSING: {
    code: 'recurring_interval_missing',
    message: 'Recurring interval missing'
  },
  AMOUNT_MISSING: {
    code: 'amount_missing',
    message: 'Amount missing'
  },
  AMOUNT_INVALID: {
    code: 'amount_invalid',
    message: 'Invalid value'
  },
  CURRENCY_MISSING: {
    code: 'currency_missing',
    message: 'Missing currency'
  },
  CARD_HOLDER_NAME_MISSING: {
    code: 'card_holder_name_missing',
    message: 'Missing credit card holder name'
  },
  CARD_TOKEN_MISSING: {
    code: 'card_token_missing',
    message: 'Missing credit card token'
  },
  CARDNO_MISSING: {
    code: 'cardno_missing',
    message: 'Missing credit card number'
  },
  CARDNO_INVALID: {
    code: 'cardno_invalid',
    message: 'Invalid credit card number'
  },
  CVV_MISSING: {
    code: 'cvv_missing',
    message: 'Missing credit card cvv'
  },
  CVV_INVALID: {
    code: 'cvv_invalid',
    message: 'Invalid credit card cvv'
  },
  EXPM_MISSING: {
    code: 'expm_missing',
    message: 'Missing credit card expiration month'
  },
  EXPM_INVALID: {
    code: 'expm_invalid',
    message: 'Invalid credit card expiration month'
  },
  EXPY_MISSING: {
    code: 'expy_missing',
    message: 'Missing credit card expiration year'
  },
  EXPY_INVALID: {
    code: 'expy_invalid',
    message: 'Invalid credit card expiration year'
  },
  STORED_CUSTOMER_FIRSTNAME_MISSING: {
    code: 'stored_customer_firstname_missing',
    message: 'Missing customer first name'
  },
  STORED_CUSTOMER_LASTNAME_MISSING: {
    code: 'stored_customer_lastname_missing',
    message: 'Missing customer last name'
  },
  STORED_CUSTOMER_EMAIL_MISSING: {
    code: 'stored_customer_email_missing',
    message: 'Missing email address'
  },
  STORED_CUSTOMER_STREET_MISSING: {
    code: 'stored_customer_street_missing',
    message: 'Missing customer street'
  },
  STORED_CUSTOMER_ZIP_CODE_MISSING: {
    code: 'stored_customer_zip_code_missing',
    message: 'Missing customer zip code'
  },
  STORED_CUSTOMER_CITY_MISSING: {
    code: 'stored_customer_city_missing',
    message: 'Missing customer city'
  },
  STORED_CUSTOMER_COUNTRY_MISSING: {
    code: 'stored_customer_country_missing',
    message: 'Missing customer country'
  },
  IBAN_MISSING: {
    code: 'iban_missing',
    message: 'Missing bank IBAN'
  },
  IBAN_INVALID: {
    code: 'iban_invalid',
    message: 'Invalid bank IBAN'
  },
  BANKBIC_MISSING: {
    code: 'bankbic_missing',
    message: 'Missing bankbic'
  },
  BANK_NAME_MISSING: {
    code: 'bank_name_missing',
    message: 'Missing bank name'
  },
  BANK_ZIP_CODE_MISSING: {
    code: 'bank_zip_code_missing',
    message: 'Missing bank zip code'
  },
  BANK_CITY_MISSING: {
    code: 'bank_city_missing',
    message: 'Missing bank city'
  },
  STORED_ES_ORDERED_MISSING: {
    code: 'stored_es_ordered_missing',
    message: 'Missing stored_es_ordered'
  },
  STORED_EZS_ORDERED_MISSING: {
    code: 'stored_ezs_ordered_missing',
    message: 'Missing stored_ezs_ordered'
  },
  PAYER_LINE1_MISSING: {
    code: 'payer_line1_missing',
    message: 'Missing payer line 1'
  },
  PAYER_LINE2_MISSING: {
    code: 'payer_line2_missing',
    message: 'Missing payer line 2'
  },
  PAYER_LINE3_MISSING: {
    code: 'payer_line3_missing',
    message: 'Missing payer line 3'
  },
  PAYER_LINE4_MISSING: {
    code: 'payer_line4_missing',
    message: 'Missing payer line 4'
  },
  REFNO_MISSING: {
    code: 'refno_missing',
    message: 'Missing refno'
  },
  MSISDN_MISSING: {
    code: 'msisdn_missing',
    message: 'Missing msisdn'
  },
  MSISDN_INVALID: {
    code: 'msisdn_invalid',
    message: 'Invalid msisdn'
  }
};

///////////////////////////////////////////////////////////////////////////////
var addError = function addError(errors, key, error) {
  if (!_isArray(errors[key])) {
    errors[key] = [];
  }

  errors[key].push(error);
  return errors;
};

var validateMsisdn = function validateMsisdn(input) {
  var format = /^\+417[56789][0-9]{7}$/;
  return format.test(input);
};

var PaymentValidator = /*#__PURE__*/function () {
  function PaymentValidator() {
    _classCallCheck(this, PaymentValidator);
  }

  _createClass(PaymentValidator, [{
    key: "validateMetadata",
    value: function validateMetadata(payment) {
      var errors = {};
      var hasSuccessUrl = !!payment.success_url;
      var hasErrorUrl = !!payment.error_url;
      var hasCancelUrl = !!payment.cancel_url;
      var hasTestMode = _keys(payment).indexOf('test_mode') !== -1;
      var isValidTestMode = validateInRange(payment.test_mode, [true, false]);
      var hasLanguage = !!payment.language;
      var hasReqtype = !!payment.reqtype;
      var isValidReqtype = payment.reqtype === 'CAA';
      var hasFurtherRnwInteraction = !!payment.further_rnw_interaction;
      var isValidFurtherRnwInteraction = validateInRange(payment.further_rnw_interaction, ['enabled', 'disabled']);

      if (!hasSuccessUrl) {
        addError(errors, 'success_url', PaymentError.SUCCESS_URL_MISSING);
      }

      if (!hasErrorUrl) {
        addError(errors, 'error_url', PaymentError.ERROR_URL_MISSING);
      }

      if (!hasCancelUrl) {
        addError(errors, 'cancel_url', PaymentError.CANCEL_URL_MISSING);
      }

      if (!hasTestMode) {
        addError(errors, 'test_mode', PaymentError.TEST_MODE_MISSING);
      } else if (!isValidTestMode) {
        addError(errors, 'test_mode', PaymentError.TEST_MODE_INVALID);
      }

      if (!hasLanguage) {
        addError(errors, 'language', PaymentError.LANGUAGE_MISSING);
      }

      if (!hasReqtype) {
        addError(errors, 'reqtype', PaymentError.REQTYPE_MISSING);
      } else if (!isValidReqtype) {
        addError(errors, 'reqtype', PaymentError.REQTYPE_INVALID);
      }

      if (!hasFurtherRnwInteraction) {
        addError(errors, 'further_rnw_interaction', PaymentError.FURTHER_RNW_INTERACTION_MISSING);
      } else if (!isValidFurtherRnwInteraction) {
        addError(errors, 'further_rnw_interaction', PaymentError.FURTHER_RNW_INTERACTION_INVALID);
      }

      return errors;
    }
  }, {
    key: "validateCreditCardIframe",
    value: function () {
      var _validateCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payment, epik, creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!creditCardIframe) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return epik.validateCreditCardIframe(creditCardIframe);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
                return _context.abrupt("return", {});

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function validateCreditCardIframe(_x, _x2, _x3) {
        return _validateCreditCardIframe.apply(this, arguments);
      }

      return validateCreditCardIframe;
    }()
  }, {
    key: "validatePaymentMethod",
    value: function validatePaymentMethod(payment) {
      var errors = {};
      var hasPaymentMethod = !!payment.payment_method;
      var isValidPaymentMethod = isSupportedPaymentMethod(payment.payment_method);

      if (!hasPaymentMethod) {
        addError(errors, 'payment_method', PaymentError.PAYMENT_METHOD_MISSING);
      } else if (!isValidPaymentMethod) {
        addError(errors, 'payment_method', PaymentError.PAYMENT_METHOD_INVALID);
      }

      return errors;
    }
  }, {
    key: "validatePaymentProvider",
    value: function validatePaymentProvider(payment) {
      var errors = {};
      var hasPaymentProvider = !!payment.payment_provider;
      var isValidPaymentProvider = isSupportedPaymentProvider(payment.payment_provider);

      if (hasPaymentProvider && !isValidPaymentProvider) {
        addError(errors, 'payment_provider', PaymentError.PAYMENT_PROVIDER_INVALID);
      }

      return errors;
    }
  }, {
    key: "validateRecurring",
    value: function validateRecurring(payment) {
      var errors = {};
      var isRecurring = !!payment.recurring;
      var isPseudoRecurring = !!payment.stored_pseudo_recurring;

      if (isRecurring || isPseudoRecurring) {
        var hasRecurringInterval = !!payment.recurring_interval;
        var hasEmail = !!payment.stored_customer_email;

        if (!hasRecurringInterval) {
          addError(errors, 'recurring_interval', PaymentError.RECURRING_INTERVAL_MISSING);
        }

        if (!hasEmail) {
          addError(errors, 'stored_customer_email', PaymentError.STORED_CUSTOMER_EMAIL_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validateAmount",
    value: function validateAmount(payment) {
      var errors = {};
      var hasAmount = !!payment.amount;
      var isValidAmount = validateNumerical(payment.amount);

      if (!hasAmount) {
        addError(errors, 'amount', PaymentError.AMOUNT_MISSING);
      } else if (!isValidAmount) {
        addError(errors, 'amount', PaymentError.AMOUNT_INVALID);
      }

      return errors;
    }
  }, {
    key: "validateCurrency",
    value: function validateCurrency(payment) {
      var errors = {};
      var hasCurrency = !!payment.currency;

      if (!hasCurrency) {
        addError(errors, 'currency', PaymentError.CURRENCY_MISSING);
      }

      return errors;
    }
  }, {
    key: "validateCreditCard",
    value: function validateCreditCard(payment, epik, creditCardIframe) {
      var errors = {};

      if (isCreditCardPaymentMethod(payment.payment_method)) {
        var hasCardHolderName = !!payment.card_holder_name;

        if (!hasCardHolderName) {
          addError(errors, 'card_holder_name', PaymentError.CARD_HOLDER_NAME_MISSING);
        }

        if (!creditCardIframe) {
          var skipCvv = !!epik.config.skipCvv;
          var hasCardNumber = !!payment.cardno;
          var hasCVV = !!payment.cvv;
          var hasExpirationMonth = !!payment.expm;
          var hasExpirationYear = !!payment.expy;
          var isValidCardNumber = validateCreditCardNumber(payment.cardno, payment.flow);
          var isValidCVV = validateCreditCardCvv(payment.cvv);
          var isValidExpirationMonth = validateCreditCardExpirationMonth(payment.expm);
          var isValidExpirationYear = validateCreditCardExpirationYear(payment.expy);

          if (!hasCardNumber) {
            addError(errors, 'cardno', PaymentError.CARDNO_MISSING);
          } else if (!isValidCardNumber) {
            addError(errors, 'cardno', PaymentError.CARDNO_INVALID);
          }

          if (!skipCvv) {
            if (!hasCVV) {
              addError(errors, 'cvv', PaymentError.CVV_MISSING);
            } else if (!isValidCVV) {
              addError(errors, 'cvv', PaymentError.CVV_INVALID);
            }
          }

          if (!hasExpirationMonth) {
            addError(errors, 'expm', PaymentError.EXPM_MISSING);
          } else if (!isValidExpirationMonth) {
            addError(errors, 'expm', PaymentError.EXPM_INVALID);
          }

          if (!hasExpirationYear) {
            addError(errors, 'expy', PaymentError.EXPY_MISSING);
          } else if (!isValidExpirationYear) {
            addError(errors, 'expy', PaymentError.EXPY_INVALID);
          }
        }

        if (creditCardIframe) {
          var hasCardToken = !!payment.card_token;

          if (!hasCardToken) {
            addError(errors, 'card_token', PaymentError.CARD_TOKEN_MISSING);
          }
        }
      }

      return errors;
    }
  }, {
    key: "validatePayu",
    value: function validatePayu(payment) {
      return {};
    }
  }, {
    key: "validateDirectDebit",
    value: function validateDirectDebit(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.DIRECT_DEBIT) {
        var hasIban = !!payment.iban;
        var hasBankName = !!payment.bank_name;
        var hasBankZipCode = !!payment.bank_zip_code;
        var hasBankCity = !!payment.bank_city;
        var isValidIban = validateIBAN(payment.iban);

        if (!hasIban) {
          addError(errors, 'iban', PaymentError.IBAN_MISSING);
        } else if (!isValidIban) {
          addError(errors, 'iban', PaymentError.IBAN_INVALID);
        }

        if (!hasBankName) {
          addError(errors, 'bank_name', PaymentError.BANK_NAME_MISSING);
        }

        if (!hasBankZipCode) {
          addError(errors, 'bank_zip_code', PaymentError.BANK_ZIP_CODE_MISSING);
        }

        if (!hasBankCity) {
          addError(errors, 'bank_city', PaymentError.BANK_CITY_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validateElv",
    value: function validateElv(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN) {
        var hasBankiban = !!payment.bankiban;
        var isValidBankiban = validateIBAN(payment.bankiban);

        if (!hasBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_MISSING);
        } else if (!isValidBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_INVALID);
        }
      }

      return errors;
    }
  }, {
    key: "validateSepaOne",
    value: function validateSepaOne(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.SEPA_ONE) {
        var hasBankiban = !!payment.bankiban;
        var isValidBankiban = validateIBAN(payment.bankiban);
        var hasBankbic = !!payment.bankbic;

        if (!hasBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_MISSING);
        } else if (!isValidBankiban) {
          addError(errors, 'bankiban', PaymentError.IBAN_INVALID);
        }

        if (!hasBankbic) {
          addError(errors, 'bankbic', PaymentError.BANKBIC_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validatePaymentSlip",
    value: function validatePaymentSlip(payment) {
      var errors = {};
      var isES = payment.payment_method === PaymentMethod.PAYMENT_SLIP;
      var isEZS = payment.payment_method === PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER;
      var hasPayerLine1 = !!payment.payer_line1;
      var hasPayerLine2 = !!payment.payer_line2;
      var hasPayerLine3 = !!payment.payer_line3;
      var hasPayerLine4 = !!payment.payer_line4;
      var hasRefno = !!payment.refno;
      var hasStoredEsOrdered = _keys(payment).indexOf('stored_es_ordered') !== -1;
      var hasStoredEzsOrdered = _keys(payment).indexOf('stored_ezs_ordered') !== -1;

      if (isES && !hasStoredEsOrdered) {
        addError(errors, 'stored_es_ordered', PaymentError.STORED_ES_ORDERED_MISSING);
      }

      if (isEZS && !hasStoredEzsOrdered) {
        addError(errors, 'stored_ezs_ordered', PaymentError.STORED_EZS_ORDERED_MISSING);
      }

      if (isES || isEZS) {
        if (!hasPayerLine1) {
          addError(errors, 'payer_line1', PaymentError.PAYER_LINE1_MISSING);
        }

        if (!hasPayerLine2) {
          addError(errors, 'payer_line2', PaymentError.PAYER_LINE2_MISSING);
        }

        if (!hasPayerLine3) {
          addError(errors, 'payer_line3', PaymentError.PAYER_LINE3_MISSING);
        }

        if (!hasPayerLine4) {
          addError(errors, 'payer_line4', PaymentError.PAYER_LINE4_MISSING);
        }
      }

      if (isEZS && !hasRefno) {
        addError(errors, 'refno', PaymentError.REFNO_MISSING);
      }

      return errors;
    }
  }, {
    key: "validateSms",
    value: function validateSms(payment) {
      var errors = {};

      if (payment.payment_method === PaymentMethod.SMS) {
        var hasMsisdn = !!payment.msisdn;
        var isValidMsisdn = validateMsisdn(payment.msisdn);

        if (!hasMsisdn) {
          addError(errors, 'msisdn', PaymentError.MSISDN_MISSING);
        } else if (!isValidMsisdn) {
          addError(errors, 'msisdn', PaymentError.MSISDN_INVALID);
        }
      }

      return errors;
    }
  }, {
    key: "validateCustomer",
    value: function validateCustomer(payment) {
      var errors = {};
      var paymentMethods = [PaymentMethod.DIRECT_DEBIT, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER];
      var validateCustomer = paymentMethods.indexOf(payment.payment_method) !== -1 || isCreditCardPaymentMethod(payment.payment_method);

      if (validateCustomer) {
        var hasStoredCustomerFirstname = !!payment.stored_customer_firstname;
        var hasStoredCustomerLastname = !!payment.stored_customer_lastname;

        if (!hasStoredCustomerFirstname) {
          addError(errors, 'stored_customer_firstname', PaymentError.STORED_CUSTOMER_FIRSTNAME_MISSING);
        }

        if (!hasStoredCustomerLastname) {
          addError(errors, 'stored_customer_lastname', PaymentError.STORED_CUSTOMER_LASTNAME_MISSING);
        }
      }

      return errors;
    }
  }, {
    key: "validateCustomerAddress",
    value: function validateCustomerAddress(payment) {
      var errors = {};
      var paymentMethods = [PaymentMethod.DIRECT_DEBIT, PaymentMethod.PAYMENT_SLIP, PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER];
      var validateCustomerAddress = paymentMethods.indexOf(payment.payment_method) !== -1 || isCreditCardPaymentMethod(payment.payment_method);

      if (validateCustomerAddress) {
        var hasStoredCustomerStreet = !!payment.stored_customer_street;
        var hasStoredCustomerZipCode = !!payment.stored_customer_zip_code;
        var hasStoredCustomerCity = !!payment.stored_customer_city;
        var hasStoredCustomerCountry = !!payment.stored_customer_country;

        if (!hasStoredCustomerStreet) {
          addError(errors, 'stored_customer_street', PaymentError.STORED_CUSTOMER_STREET_MISSING);
        }

        if (!hasStoredCustomerZipCode) {
          addError(errors, 'stored_customer_zip_code', PaymentError.STORED_CUSTOMER_ZIP_CODE_MISSING);
        }

        if (!hasStoredCustomerCity) {
          addError(errors, 'stored_customer_city', PaymentError.STORED_CUSTOMER_CITY_MISSING);
        }

        if (!hasStoredCustomerCountry) {
          addError(errors, 'stored_customer_country', PaymentError.STORED_CUSTOMER_COUNTRY_MISSING);
        }
      }

      return errors;
    }
  }]);

  return PaymentValidator;
}(); ///////////////////////////////////////////////////////////////////////////////

var createPaymentValidator = function createPaymentValidator() {
  return new PaymentValidator();
};

///////////////////////////////////////////////////////////////////////////////
var TransactionStatusPoll = /*#__PURE__*/function () {
  function TransactionStatusPoll(epik) {
    _classCallCheck(this, TransactionStatusPoll);

    this.epik = void 0;
    this.timerId = void 0;
    this.counter = void 0;
    this.eppTransactionId = void 0;
    this.epik = epik;
  }

  _createClass(TransactionStatusPoll, [{
    key: "start",
    value: function start(eppTransactionId) {
      if (!eppTransactionId) {
        console.error('You must specify eppTransactionId');
        return;
      }

      if (this.eppTransactionId) {
        console.error('Transaction status polling already started');
        return;
      }

      this.reset();
      this.eppTransactionId = eppTransactionId;
      this.poll();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.reset();
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return !!this.eppTransactionId && !!this.timerId;
    }
  }, {
    key: "reset",
    value: function reset() {
      clearTimeout(this.timerId);
      this.timerId = null;
      this.counter = 0;
      this.eppTransactionId = null;
    }
  }, {
    key: "poll",
    value: function () {
      var _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var transactionInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.eppTransactionId) {
                  _context.next = 3;
                  break;
                }

                this.reset();
                return _context.abrupt("return");

              case 3:
                this.counter++;
                _context.next = 6;
                return this.epik.fetchTransaction(this.eppTransactionId);

              case 6:
                transactionInfo = _context.sent;
                _context.next = 9;
                return this.epik.events[EpikEventName.TRANSACTION_STATUS_POLL].publish({
                  transactionInfo: transactionInfo
                });

              case 9:
                this.timerId = setTimeout(this.poll.bind(this), this.epik.config.transactionStatusPollInterval);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function poll() {
        return _poll.apply(this, arguments);
      }

      return poll;
    }()
  }]);

  return TransactionStatusPoll;
}(); ///////////////////////////////////////////////////////////////////////////////

var createTransactionStatusPoll = function createTransactionStatusPoll(epik) {
  return new TransactionStatusPoll(epik);
};

var HistoryMode;

(function (HistoryMode) {
  HistoryMode["BROWSER"] = "browser";
  HistoryMode["HASH"] = "hash";
})(HistoryMode || (HistoryMode = {}));

///////////////////////////////////////////////////////////////////////////////
var createRouter = function createRouter() {
  var historyMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HistoryMode.BROWSER;

  var getHistoryMode = function getHistoryMode() {
    return historyMode;
  };

  var getLocation = function getLocation() {
    var url = null;

    if (historyMode === HistoryMode.BROWSER) {
      url = window.location.href;
    }

    if (historyMode === HistoryMode.HASH) {
      url = window.location.hash.replace(/^#/, '');
    }

    return getLocationFromUrl(url);
  };

  var getLocationFromUrl = function getLocationFromUrl(url) {
    if (url === "") {
      return {
        pathname: "/",
        search: "",
        hash: ""
      };
    }

    var a = document.createElement('a');
    a.href = url;
    var pathname = a.pathname,
        search = a.search,
        hash = a.hash; // ie11 doesn't have leading slash

    if (pathname[0] !== '/') {
      pathname = "/".concat(pathname);
    }

    return {
      pathname: pathname,
      search: search,
      hash: hash
    };
  };

  var buildFullUrlFromLocation = function buildFullUrlFromLocation(location) {
    var pathname = location.pathname,
        search = location.search,
        hash = location.hash;

    if (historyMode === HistoryMode.BROWSER) {
      return pathname + search + hash;
    }

    if (historyMode === HistoryMode.HASH) {
      var hashUrl = pathname + search + hash;
      var _window$location = window.location,
          wPathname = _window$location.pathname,
          wSearch = _window$location.search;
      return wPathname + wSearch + '#' + hashUrl;
    }
  };

  var push = function push(rawUrl) {
    var location = getLocationFromUrl(rawUrl);
    var url = buildFullUrlFromLocation(location);
    window.history.pushState(null, null, url);
  };

  var replace = function replace(rawUrl) {
    var location = getLocationFromUrl(rawUrl);
    var url = buildFullUrlFromLocation(location);
    window.history.replaceState(null, null, url);
  };

  var listen = function listen(locationChangeHandler) {
    var cb = function cb() {
      return locationChangeHandler(getLocation());
    };

    window.addEventListener('rnw.locationchange', cb);
    return function () {
      return window.removeEventListener('rnw.locationchange', cb);
    };
  };

  return {
    getHistoryMode: getHistoryMode,
    getLocation: getLocation,
    push: push,
    replace: replace,
    listen: listen
  };
};

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

///////////////////////////////////////////////////////////////////////////////
var Epik = /*#__PURE__*/function () {
  function Epik(args) {
    _classCallCheck(this, Epik);

    this.window = void 0;
    this.config = void 0;
    this.eppProxy = void 0;
    this.epmsProxy = void 0;
    this.validator = void 0;
    this.preparator = void 0;
    this.cronHelper = void 0;
    this.events = void 0;
    this.transactionStatusPoll = void 0;
    this.router = void 0;
    this.watchedQueryParams = void 0;
    var config = args.config,
        win = args.win,
        eppProxy = args.eppProxy,
        epmsProxy = args.epmsProxy,
        validator = args.validator,
        preparator = args.preparator,
        cronHelper = args.cronHelper,
        epikEvents = args.epikEvents,
        transactionStatusPoll = args.transactionStatusPoll;
    this.config = config;
    this.window = win || window;
    this.eppProxy = eppProxy || createEppApiProxy(this.config.eppProxyUrl);
    this.epmsProxy = epmsProxy || createEpmsApiProxy(this.config.epmsProxyUrl);
    this.validator = validator || createPaymentValidator();
    this.preparator = preparator || createPaymentPreparator();
    this.cronHelper = cronHelper || createCronHelper();
    this.events = epikEvents || createEpikEvents();
    this.transactionStatusPoll = transactionStatusPoll || createTransactionStatusPoll(this);
    this.router = createRouter(HistoryMode.BROWSER);
    this.watchedQueryParams = {};
    this.initLocationChangeHandling();
    this.initEventsHandling();
  }

  _createClass(Epik, [{
    key: "init",
    value: function init() {
      this.handleLocationChange(this.router.getLocation());
    }
  }, {
    key: "initLocationChangeHandling",
    value: function initLocationChangeHandling() {
      this.router.listen(this.handleLocationChange.bind(this));
    }
  }, {
    key: "handleLocationChange",
    value: function handleLocationChange(location) {
      var params = getLocationParams(this.router);

      var watchedQueryParams = _pick(params, WatchedEpikQueryParams);

      if (!_isEqual(watchedQueryParams, this.watchedQueryParams)) {
        this.watchedQueryParams = watchedQueryParams;
        this.fetchAndPublishPaymentData();
      }
    }
  }, {
    key: "initEventsHandling",
    value: function initEventsHandling() {
      var _this = this;

      var eventNames = [EpikEventName.FETCH_PAYMENT_DATA_START, EpikEventName.FETCH_PAYMENT_DATA_END, EpikEventName.SEND_EPP_PAYMENT_START, EpikEventName.SEND_EPMS_PAYMENT_START, EpikEventName.SEND_EPMS_PAYMENT_END, EpikEventName.UPDATE_EPMS_SUBSCRIPTION_START, EpikEventName.UPDATE_EPMS_SUBSCRIPTION_END];

      _each(eventNames, function (eventName) {
        _this.events[eventName].subscribe(function (event) {
          _this.config.debug && console.debug('[epik]', event.eventName, event.data);
        });
      });

      this.events[EpikEventName.FETCH_PAYMENT_DATA_END].subscribe( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.tryStartTransactionStatusPoll(event.data.transactionInfo);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.events[EpikEventName.TRANSACTION_STATUS_POLL].subscribe( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
          var transactionInfo, status;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  transactionInfo = event.data.transactionInfo;
                  status = transactionInfo && transactionInfo.epayment_status;
                  _this.config.debug && console.debug('[epik]', event.eventName, status);
                  _context2.next = 5;
                  return _this.tryStopTransactionStatusPoll(transactionInfo);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
      this.events[EpikEventName.SEND_EPMS_PAYMENT_END].subscribe(function (event) {
        var _event$data = event.data,
            epmsPaymentRequestData = _event$data.epmsPaymentRequestData,
            epmsPaymentResponseData = _event$data.epmsPaymentResponseData,
            returnUrl = _event$data.returnUrl;

        if (epmsPaymentResponseData) {
          var action_type = _get(epmsPaymentResponseData, 'action.action_type');

          var action_url = _get(epmsPaymentResponseData, 'action.url');

          var payment_uuid = _get(epmsPaymentResponseData, 'objects.payment_uuid');

          var subscription_uuid = _get(epmsPaymentResponseData, 'objects.subscription_uuid');

          if ((epmsPaymentRequestData === null || epmsPaymentRequestData === void 0 ? void 0 : epmsPaymentRequestData.payment_method) === 'twint') {
            if (action_type === 'redirect' && action_url) {
              _this.config.debug && console.debug('[epik] open TWINT app url', action_url);
              window.location.href = action_url;
            }

            return;
          }

          if (returnUrl) {
            if (payment_uuid) {
              returnUrl = updateUrlParams(returnUrl, _defineProperty({}, EpikQueryParam.EPMS_PAYMENT_UUID, payment_uuid));
            }

            if (subscription_uuid) {
              returnUrl = updateUrlParams(returnUrl, _defineProperty({}, EpikQueryParam.EPMS_SUBSCRIPTION_UUID, subscription_uuid));
            }

            window.location.href = returnUrl;
            return;
          }
        }
      });
      this.events[EpikEventName.UPDATE_EPMS_SUBSCRIPTION_END].subscribe(function (event) {
        var _ref3 = event.data || {},
            epmsSubscriptionUuid = _ref3.epmsSubscriptionUuid,
            returnUrl = _ref3.returnUrl;

        if (returnUrl && epmsSubscriptionUuid) {
          returnUrl = updateUrlParams(returnUrl, _defineProperty({}, EpikQueryParam.EPMS_SUBSCRIPTION_UUID, epmsSubscriptionUuid));
        }

        window.location.href = returnUrl;
      });
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "updateCurrentUrl",
    value: function updateCurrentUrl(args) {
      var updatedUrl = getUpdatedUrl(this.router)(args);
      this.router.push(updatedUrl);
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "fetchAndPublishPaymentData",
    value: function () {
      var _fetchAndPublishPaymentData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var params, eppTransactionId, subscriptionToken, customerToken, epmsPaymentUuid, epmsSubscriptionUuid, epmsPaymentSourceUuid, transactionInfo, subscriptionInfo, customerInfo, epmsPaymentInfo, epmsSubscriptionInfo, epmsPaymentSourceInfo, transactionError, subscriptionError, customerError, epmsPaymentError, epmsSubscriptionError, epmsPaymentSourceError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.events[EpikEventName.FETCH_PAYMENT_DATA_START].publish();

              case 2:
                params = getLocationParams(this.router);
                eppTransactionId = params[EpikQueryParam.EPP_TRANSACTION_ID];
                subscriptionToken = params[EpikQueryParam.SUBSCRIPTION_TOKEN];
                customerToken = params[EpikQueryParam.CUSTOMER_TOKEN];
                epmsPaymentUuid = params[EpikQueryParam.EPMS_PAYMENT_UUID];
                epmsSubscriptionUuid = params[EpikQueryParam.EPMS_SUBSCRIPTION_UUID];
                epmsPaymentSourceUuid = null;
                transactionInfo = null;
                subscriptionInfo = null;
                customerInfo = null;
                epmsPaymentInfo = null;
                epmsSubscriptionInfo = null;
                epmsPaymentSourceInfo = null;
                transactionError = null;
                subscriptionError = null;
                customerError = null;
                epmsPaymentError = null;
                epmsSubscriptionError = null;
                epmsPaymentSourceError = null; // epp

                if (!eppTransactionId) {
                  _context3.next = 33;
                  break;
                }

                _context3.prev = 22;
                _context3.next = 25;
                return this.fetchTransaction(eppTransactionId);

              case 25:
                transactionInfo = _context3.sent;

                if (transactionInfo && transactionInfo.subscription_token && !subscriptionToken) {
                  subscriptionToken = transactionInfo.subscription_token;
                }

                _context3.next = 33;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t0 = _context3["catch"](22);
                console.log('fetch transaction error', _context3.t0);
                transactionError = {
                  code: 'NOT_FOUND'
                };

              case 33:
                if (!subscriptionToken) {
                  _context3.next = 45;
                  break;
                }

                _context3.prev = 34;
                _context3.next = 37;
                return this.fetchSubscription(subscriptionToken);

              case 37:
                subscriptionInfo = _context3.sent;

                if (subscriptionInfo && subscriptionInfo.customer_token && !customerToken) {
                  customerToken = subscriptionInfo.customer_token;
                }

                _context3.next = 45;
                break;

              case 41:
                _context3.prev = 41;
                _context3.t1 = _context3["catch"](34);
                console.log('fetch subscription error', _context3.t1);
                subscriptionError = {
                  code: 'NOT_FOUND'
                };

              case 45:
                if (!customerToken) {
                  _context3.next = 56;
                  break;
                }

                _context3.prev = 46;
                _context3.next = 49;
                return this.fetchCustomer(customerToken);

              case 49:
                customerInfo = _context3.sent;
                _context3.next = 56;
                break;

              case 52:
                _context3.prev = 52;
                _context3.t2 = _context3["catch"](46);
                console.log('fetch customer error', _context3.t2);
                customerError = {
                  code: 'NOT_FOUND'
                };

              case 56:
                if (!epmsPaymentUuid) {
                  _context3.next = 68;
                  break;
                }

                _context3.prev = 57;
                _context3.next = 60;
                return this.fetchEpmsPayment(epmsPaymentUuid);

              case 60:
                epmsPaymentInfo = _context3.sent;

                if (epmsPaymentInfo && epmsPaymentInfo.created_subscription_uuid && !epmsSubscriptionUuid) {
                  epmsSubscriptionUuid = epmsPaymentInfo.created_subscription_uuid;
                }

                _context3.next = 68;
                break;

              case 64:
                _context3.prev = 64;
                _context3.t3 = _context3["catch"](57);
                console.log('fetch epms payment error', _context3.t3);
                epmsPaymentError = {
                  code: 'NOT_FOUND'
                };

              case 68:
                if (!epmsSubscriptionUuid) {
                  _context3.next = 80;
                  break;
                }

                _context3.prev = 69;
                _context3.next = 72;
                return this.fetchEpmsSubscription(epmsSubscriptionUuid);

              case 72:
                epmsSubscriptionInfo = _context3.sent;

                if (epmsSubscriptionInfo) {
                  epmsPaymentSourceUuid = epmsSubscriptionInfo.payment_source_uuid;
                }

                _context3.next = 80;
                break;

              case 76:
                _context3.prev = 76;
                _context3.t4 = _context3["catch"](69);
                console.log('fetch epms subscription error', _context3.t4);
                epmsSubscriptionError = {
                  code: 'NOT_FOUND'
                };

              case 80:
                if (!(epmsSubscriptionInfo && !epmsPaymentInfo)) {
                  _context3.next = 92;
                  break;
                }

                _context3.prev = 81;
                _context3.next = 84;
                return this.fetchEpmsPaymentBySubscriptionUuid(epmsSubscriptionInfo.uuid);

              case 84:
                epmsPaymentInfo = _context3.sent;
                epmsPaymentError = null;
                _context3.next = 92;
                break;

              case 88:
                _context3.prev = 88;
                _context3.t5 = _context3["catch"](81);
                console.log('fetch epms payment error', _context3.t5);
                epmsPaymentError = {
                  code: 'NOT_FOUND'
                };

              case 92:
                if (!epmsPaymentSourceUuid) {
                  _context3.next = 103;
                  break;
                }

                _context3.prev = 93;
                _context3.next = 96;
                return this.fetchEpmsPaymentSource(epmsPaymentSourceUuid);

              case 96:
                epmsPaymentSourceInfo = _context3.sent;
                _context3.next = 103;
                break;

              case 99:
                _context3.prev = 99;
                _context3.t6 = _context3["catch"](93);
                console.log('fetch epms payment source error', _context3.t6);
                epmsPaymentSourceError = {
                  code: 'NOT_FOUND'
                };

              case 103:
                _context3.next = 105;
                return this.events[EpikEventName.FETCH_PAYMENT_DATA_END].publish({
                  transactionInfo: transactionInfo,
                  subscriptionInfo: subscriptionInfo,
                  customerInfo: customerInfo,
                  epmsPaymentInfo: epmsPaymentInfo,
                  epmsSubscriptionInfo: epmsSubscriptionInfo,
                  epmsPaymentSourceInfo: epmsPaymentSourceInfo,
                  transactionError: transactionError,
                  subscriptionError: subscriptionError,
                  customerError: customerError,
                  epmsPaymentError: epmsPaymentError,
                  epmsSubscriptionError: epmsSubscriptionError,
                  epmsPaymentSourceError: epmsPaymentSourceError
                });

              case 105:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[22, 29], [34, 41], [46, 52], [57, 64], [69, 76], [81, 88], [93, 99]]);
      }));

      function fetchAndPublishPaymentData() {
        return _fetchAndPublishPaymentData.apply(this, arguments);
      }

      return fetchAndPublishPaymentData;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "createPayment",
    value: function createPayment$1(payment) {
      return createPayment(this, payment);
    }
  }, {
    key: "getCreditCardToken",
    value: function () {
      var _getCreditCardToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(args) {
        var _this$config, eppApiUrl, eppApiKey, epmsApiUrl, epmsAccountUuid, skipCvv, flow, cardno, expm, expy, cvv, payloadData, _yield$axios$request, data, _payloadData, _yield$axios$request2, _data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$config = this.config, eppApiUrl = _this$config.eppApiUrl, eppApiKey = _this$config.eppApiKey, epmsApiUrl = _this$config.epmsApiUrl, epmsAccountUuid = _this$config.epmsAccountUuid, skipCvv = _this$config.skipCvv;
                flow = args.flow, cardno = args.cardno, expm = args.expm, expy = args.expy, cvv = args.cvv;
                expy = prepareExpirationYear(expy, flow);

                if (!(flow == PaymentFlow.EPP)) {
                  _context4.next = 13;
                  break;
                }

                payloadData = {
                  cardno: cardno,
                  expm: expm,
                  expy: expy,
                  merchant_config_identifier: eppApiKey
                };

                if (!skipCvv) {
                  payloadData['cvv'] = cvv;
                }

                _context4.next = 8;
                return axios.request({
                  url: eppApiUrl + '/api/v1/card/token',
                  method: 'post',
                  data: payloadData
                });

              case 8:
                _yield$axios$request = _context4.sent;
                data = _yield$axios$request.data;
                return _context4.abrupt("return", data.token);

              case 13:
                if (!(flow === PaymentFlow.EPMS)) {
                  _context4.next = 21;
                  break;
                }

                _payloadData = {
                  payment_information: {
                    number: cardno,
                    expiry_month: expm,
                    expiry_year: expy
                  },
                  account_uuid: epmsAccountUuid
                };

                if (!skipCvv) {
                  _payloadData['payment_information']['cvv'] = cvv;
                }

                _context4.next = 18;
                return axios.request({
                  url: epmsApiUrl + '/payment-tokens',
                  method: 'post',
                  data: _payloadData
                });

              case 18:
                _yield$axios$request2 = _context4.sent;
                _data = _yield$axios$request2.data;
                return _context4.abrupt("return", _data.token);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCreditCardToken(_x3) {
        return _getCreditCardToken.apply(this, arguments);
      }

      return getCreditCardToken;
    }()
  }, {
    key: "createCreditCardIframe",
    value: function () {
      var _createCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(targetSelector, url, flow) {
        var _this2 = this;

        var debug, channel, iframeUrl, options, iframe, messenger, setCreditCardIframeHeight;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                debug = this.config.debug;
                channel = 'rnw.epik.' + Date.now().toString();
                iframeUrl = updateUrlParams(url, {
                  channel: channel,
                  debug: debug,
                  flow: flow
                });
                options = {
                  name: 'credit-card-iframe'
                };
                _context5.next = 6;
                return createAndInjectIframe(this.window.document, options, targetSelector);

              case 6:
                iframe = _context5.sent;
                messenger = new Messenger({
                  listenTo: window,
                  emitTo: iframe.contentWindow,
                  label: 'main',
                  channel: channel,
                  debug: debug
                });

                setCreditCardIframeHeight = function setCreditCardIframeHeight(height) {
                  return iframe.style.height = "".concat(height, "px");
                };

                messenger.on(CreditCardIframeMessageType.HEIGHT, function (height) {
                  return setCreditCardIframeHeight(height);
                });
                messenger.respond(CreditCardIframeMessageType.EPIK_CONFIG, function () {
                  return _this2.config;
                }); // set iframe src after messenger subscriptions

                iframe.src = iframeUrl;
                return _context5.abrupt("return", {
                  iframe: iframe,
                  messenger: messenger
                });

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createCreditCardIframe(_x4, _x5, _x6) {
        return _createCreditCardIframe.apply(this, arguments);
      }

      return createCreditCardIframe;
    }()
  }, {
    key: "validateCreditCardIframe",
    value: function () {
      var _validateCreditCardIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", creditCardIframe.messenger.request(CreditCardIframeMessageType.VALIDATE));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function validateCreditCardIframe(_x7) {
        return _validateCreditCardIframe.apply(this, arguments);
      }

      return validateCreditCardIframe;
    }()
  }, {
    key: "acquireCreditCardTokenFromIframe",
    value: function () {
      var _acquireCreditCardTokenFromIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", creditCardIframe.messenger.request(CreditCardIframeMessageType.TOKENIZE));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function acquireCreditCardTokenFromIframe(_x8) {
        return _acquireCreditCardTokenFromIframe.apply(this, arguments);
      }

      return acquireCreditCardTokenFromIframe;
    }()
  }, {
    key: "acquireCreditCardTypeFromIframe",
    value: function () {
      var _acquireCreditCardTypeFromIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(creditCardIframe) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", creditCardIframe.messenger.request(CreditCardIframeMessageType.DETECT_CREDIT_CARD_TYPE));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function acquireCreditCardTypeFromIframe(_x9) {
        return _acquireCreditCardTypeFromIframe.apply(this, arguments);
      }

      return acquireCreditCardTypeFromIframe;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payment, creditCardIframe) {
        var paymentFlow;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.preparePayment(payment, creditCardIframe);

              case 2:
                payment = _context9.sent;
                cleanBlankFields(payment);
                paymentFlow = this.getPaymentFlow(payment);
                _context9.next = 7;
                return paymentFlow.start(this, payment, this.window);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function sendPayment(_x10, _x11) {
        return _sendPayment.apply(this, arguments);
      }

      return sendPayment;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "validatePayment",
    value: function () {
      var _validatePayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payment, creditCardIframe) {
        var errors;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.preparePayment(payment, creditCardIframe);

              case 2:
                payment = _context10.sent;
                _context10.t0 = _objectSpread;
                _context10.t1 = _objectSpread;
                _context10.t2 = _objectSpread;
                _context10.t3 = _objectSpread;
                _context10.t4 = _objectSpread;
                _context10.t5 = _objectSpread;
                _context10.t6 = _objectSpread;
                _context10.t7 = _objectSpread;
                _context10.t8 = _objectSpread;
                _context10.t9 = _objectSpread;
                _context10.t10 = _objectSpread;
                _context10.t11 = _objectSpread;
                _context10.t12 = _objectSpread;
                _context10.t13 = _objectSpread;
                _context10.t14 = _objectSpread;
                _context10.t15 = _objectSpread({}, this.validator.validateMetadata(payment));
                _context10.next = 21;
                return this.validator.validateCreditCardIframe(payment, this, creditCardIframe);

              case 21:
                _context10.t16 = _context10.sent;
                _context10.t17 = (0, _context10.t14)(_context10.t15, _context10.t16);
                _context10.t18 = this.validator.validatePaymentMethod(payment);
                _context10.t19 = (0, _context10.t13)(_context10.t17, _context10.t18);
                _context10.t20 = this.validator.validatePaymentProvider(payment);
                _context10.t21 = (0, _context10.t12)(_context10.t19, _context10.t20);
                _context10.t22 = this.validator.validateRecurring(payment);
                _context10.t23 = (0, _context10.t11)(_context10.t21, _context10.t22);
                _context10.t24 = this.validator.validateAmount(payment);
                _context10.t25 = (0, _context10.t10)(_context10.t23, _context10.t24);
                _context10.t26 = this.validator.validateCurrency(payment);
                _context10.t27 = (0, _context10.t9)(_context10.t25, _context10.t26);
                _context10.t28 = this.validator.validateCreditCard(payment, this, creditCardIframe);
                _context10.t29 = (0, _context10.t8)(_context10.t27, _context10.t28);
                _context10.t30 = this.validator.validatePayu(payment);
                _context10.t31 = (0, _context10.t7)(_context10.t29, _context10.t30);
                _context10.t32 = this.validator.validateDirectDebit(payment);
                _context10.t33 = (0, _context10.t6)(_context10.t31, _context10.t32);
                _context10.t34 = this.validator.validateElv(payment);
                _context10.t35 = (0, _context10.t5)(_context10.t33, _context10.t34);
                _context10.t36 = this.validator.validateSepaOne(payment);
                _context10.t37 = (0, _context10.t4)(_context10.t35, _context10.t36);
                _context10.t38 = this.validator.validatePaymentSlip(payment);
                _context10.t39 = (0, _context10.t3)(_context10.t37, _context10.t38);
                _context10.t40 = this.validator.validateSms(payment);
                _context10.t41 = (0, _context10.t2)(_context10.t39, _context10.t40);
                _context10.t42 = this.validator.validateCustomer(payment);
                _context10.t43 = (0, _context10.t1)(_context10.t41, _context10.t42);
                _context10.t44 = this.validator.validateCustomerAddress(payment);
                errors = (0, _context10.t0)(_context10.t43, _context10.t44);
                return _context10.abrupt("return", _keys(errors).length > 0 ? errors : null);

              case 52:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function validatePayment(_x12, _x13) {
        return _validatePayment.apply(this, arguments);
      }

      return validatePayment;
    }()
  }, {
    key: "preparePayment",
    value: function () {
      var _preparePayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payment, creditCardIframe) {
        var _context11;

        var relevantFields;
        return _regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                payment = _cloneDeep(payment);
                _context12.t0 = _concatInstanceProperty(_context11 = []);
                _context12.t1 = _context11;
                _context12.t2 = _toConsumableArray(this.preparator.prepareMetadata(payment, this));
                _context12.t3 = _toConsumableArray(this.preparator.prepareHmac(payment));
                _context12.t4 = _toConsumableArray(this.preparator.prepareRecurring(payment, this));
                _context12.t5 = _toConsumableArray;
                _context12.next = 9;
                return this.preparator.prepareCreditCard(payment, this, creditCardIframe);

              case 9:
                _context12.t6 = _context12.sent;
                _context12.t7 = (0, _context12.t5)(_context12.t6);
                _context12.t8 = _toConsumableArray(this.preparator.preparePayu(payment));
                _context12.t9 = _toConsumableArray(this.preparator.prepareDirectDebit(payment));
                _context12.t10 = _toConsumableArray(this.preparator.prepareElv(payment));
                _context12.t11 = _toConsumableArray(this.preparator.prepareSepaOne(payment));
                _context12.t12 = _toConsumableArray;
                _context12.next = 18;
                return this.preparator.preparePaymentSlip(payment, this);

              case 18:
                _context12.t13 = _context12.sent;
                _context12.t14 = (0, _context12.t12)(_context12.t13);
                _context12.t15 = _toConsumableArray(this.preparator.prepareSms(payment));
                _context12.t16 = _toConsumableArray(this.preparator.prepareCustomFields(payment));
                relevantFields = _context12.t0.call.call(_context12.t0, _context12.t1, _context12.t2, _context12.t3, _context12.t4, _context12.t7, _context12.t8, _context12.t9, _context12.t10, _context12.t11, _context12.t14, _context12.t15, _context12.t16);
                return _context12.abrupt("return", _pick(payment, relevantFields));

              case 24:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee11, this);
      }));

      function preparePayment(_x14, _x15) {
        return _preparePayment.apply(this, arguments);
      }

      return preparePayment;
    }() /////////////////////////////////////////////////////////////////////////////
    // epp
    /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "fetchTransaction",
    value: function () {
      var _fetchTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(eppTransactionId) {
        var eppApiKey, data;
        return _regeneratorRuntime.wrap(function _callee12$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context13.next = 3;
                return this.eppProxy.fetchTransaction({
                  eppApiKey: eppApiKey,
                  eppTransactionId: eppTransactionId
                });

              case 3:
                data = _context13.sent;
                data = this.prepareTransactionInfo(data);
                return _context13.abrupt("return", data);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee12, this);
      }));

      function fetchTransaction(_x16) {
        return _fetchTransaction.apply(this, arguments);
      }

      return fetchTransaction;
    }()
  }, {
    key: "fetchSubscription",
    value: function () {
      var _fetchSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(subscriptionToken) {
        var eppApiKey, data;
        return _regeneratorRuntime.wrap(function _callee13$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context14.next = 3;
                return this.eppProxy.fetchSubscription({
                  eppApiKey: eppApiKey,
                  subscriptionToken: subscriptionToken
                });

              case 3:
                data = _context14.sent;
                data.subscription_token = subscriptionToken;
                data = this.prepareSubscriptionInfo(data);
                return _context14.abrupt("return", data);

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee13, this);
      }));

      function fetchSubscription(_x17) {
        return _fetchSubscription.apply(this, arguments);
      }

      return fetchSubscription;
    }()
  }, {
    key: "cancelSubscription",
    value: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(subscriptionToken) {
        var eppApiKey;
        return _regeneratorRuntime.wrap(function _callee14$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context15.next = 3;
                return this.eppProxy.cancelSubscription({
                  eppApiKey: eppApiKey,
                  subscriptionToken: subscriptionToken
                });

              case 3:
                return _context15.abrupt("return", this.fetchSubscription(subscriptionToken));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee14, this);
      }));

      function cancelSubscription(_x18) {
        return _cancelSubscription.apply(this, arguments);
      }

      return cancelSubscription;
    }()
  }, {
    key: "fetchCustomer",
    value: function () {
      var _fetchCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(customerToken) {
        var eppApiKey;
        return _regeneratorRuntime.wrap(function _callee15$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                return _context16.abrupt("return", this.eppProxy.fetchCustomer({
                  eppApiKey: eppApiKey,
                  customerToken: customerToken
                }));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee15, this);
      }));

      function fetchCustomer(_x19) {
        return _fetchCustomer.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: "updateCustomer",
    value: function () {
      var _updateCustomer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(customerToken, fields) {
        var eppApiKey;
        return _regeneratorRuntime.wrap(function _callee16$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                eppApiKey = this.config.eppApiKey;
                _context17.next = 3;
                return this.eppProxy.updateCustomer({
                  eppApiKey: eppApiKey,
                  customerToken: customerToken,
                  fields: fields
                });

              case 3:
                return _context17.abrupt("return", this.fetchCustomer(customerToken));

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateCustomer(_x20, _x21) {
        return _updateCustomer.apply(this, arguments);
      }

      return updateCustomer;
    }()
  }, {
    key: "fetchReferenceNumber",
    value: function () {
      var _fetchReferenceNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(campaignId) {
        var _this$config2, eppApiKey, eppMerchantId;

        return _regeneratorRuntime.wrap(function _callee17$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _this$config2 = this.config, eppApiKey = _this$config2.eppApiKey, eppMerchantId = _this$config2.eppMerchantId;
                return _context18.abrupt("return", this.eppProxy.fetchReferenceNumber({
                  eppApiKey: eppApiKey,
                  eppMerchantId: eppMerchantId,
                  campaignId: campaignId
                }));

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee17, this);
      }));

      function fetchReferenceNumber(_x22) {
        return _fetchReferenceNumber.apply(this, arguments);
      }

      return fetchReferenceNumber;
    }() /////////////////////////////////////////////////////////////////////////////
    // epms
    /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "fetchEpmsPayment",
    value: function () {
      var _fetchEpmsPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(epmsPaymentUuid) {
        return _regeneratorRuntime.wrap(function _callee18$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this.epmsProxy.fetchPayment({
                  epmsPaymentUuid: epmsPaymentUuid
                }));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee18, this);
      }));

      function fetchEpmsPayment(_x23) {
        return _fetchEpmsPayment.apply(this, arguments);
      }

      return fetchEpmsPayment;
    }()
  }, {
    key: "fetchEpmsSubscription",
    value: function () {
      var _fetchEpmsSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(epmsSubscriptionUuid) {
        return _regeneratorRuntime.wrap(function _callee19$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this.epmsProxy.fetchSubscription({
                  epmsSubscriptionUuid: epmsSubscriptionUuid
                }));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee19, this);
      }));

      function fetchEpmsSubscription(_x24) {
        return _fetchEpmsSubscription.apply(this, arguments);
      }

      return fetchEpmsSubscription;
    }()
  }, {
    key: "fetchEpmsPaymentSource",
    value: function () {
      var _fetchEpmsPaymentSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(epmsPaymentSourceUuid) {
        return _regeneratorRuntime.wrap(function _callee20$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this.epmsProxy.fetchPaymentSource({
                  epmsPaymentSourceUuid: epmsPaymentSourceUuid
                }));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee20, this);
      }));

      function fetchEpmsPaymentSource(_x25) {
        return _fetchEpmsPaymentSource.apply(this, arguments);
      }

      return fetchEpmsPaymentSource;
    }()
  }, {
    key: "fetchEpmsPaymentBySubscriptionUuid",
    value: function () {
      var _fetchEpmsPaymentBySubscriptionUuid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(epmsSubscriptionUuid) {
        return _regeneratorRuntime.wrap(function _callee21$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this.epmsProxy.fetchPaymentBySubscriptionUuid({
                  epmsSubscriptionUuid: epmsSubscriptionUuid
                }));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee21, this);
      }));

      function fetchEpmsPaymentBySubscriptionUuid(_x26) {
        return _fetchEpmsPaymentBySubscriptionUuid.apply(this, arguments);
      }

      return fetchEpmsPaymentBySubscriptionUuid;
    }()
  }, {
    key: "cancelEpmsSubscription",
    value: function () {
      var _cancelEpmsSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(epmsSubscriptionUuid) {
        return _regeneratorRuntime.wrap(function _callee22$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this.epmsProxy.cancelSubscription({
                  epmsSubscriptionUuid: epmsSubscriptionUuid
                }));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee22, this);
      }));

      function cancelEpmsSubscription(_x27) {
        return _cancelEpmsSubscription.apply(this, arguments);
      }

      return cancelEpmsSubscription;
    }() /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "getPaymentFlow",
    value: function getPaymentFlow(payment) {
      var paymentFlow = null;
      var supportedPaymentFlows = getSupportedPaymentFlows(payment.payment_method);

      if (payment.flow && supportedPaymentFlows.indexOf(payment.flow) !== -1) {
        paymentFlow = payment.flow;
      } else {
        paymentFlow = supportedPaymentFlows[0];
      }

      delete payment.flow;
      return createPaymentFlow(paymentFlow);
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "prepareTransactionInfo",
    value: function prepareTransactionInfo(data) {
      data = this.normalizedCurrency(data);
      data = this.normalizedPaymentMethod(data);
      data = this.normalizedFinalStatus(data);
      return data;
    }
  }, {
    key: "prepareSubscriptionInfo",
    value: function prepareSubscriptionInfo(data) {
      data = this.normalizedCurrency(data);
      data = this.normalizedPaymentMethod(data);
      return data;
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "normalizedCurrency",
    value: function normalizedCurrency(data) {
      data = _cloneDeep(data);
      data.currency = (data.currency || '').toLowerCase();
      return data;
    }
  }, {
    key: "normalizedPaymentMethod",
    value: function normalizedPaymentMethod(data) {
      data = _cloneDeep(data);
      data.payment_method = (data.payment_method || '').toLowerCase();
      return data;
    }
  }, {
    key: "normalizedFinalStatus",
    value: function normalizedFinalStatus(data) {
      data = _cloneDeep(data);
      var finalStatusesMap = {
        'success': TransactionStatus.SUCCESS,
        'aborted_by_user': TransactionStatus.CANCEL,
        'final_success': TransactionStatus.SUCCESS,
        'error_from_paymentprovider': TransactionStatus.ERROR,
        'final_error': TransactionStatus.ERROR,
        'final_cancel': TransactionStatus.CANCEL,
        'authorization_success': TransactionStatus.SUCCESS,
        'success_from_payment_provider': TransactionStatus.SUCCESS,
        'timeout': TransactionStatus.CANCEL
      };

      if (_isArray(data.status)) {
        var statusesCount = data.status.length;
        var finalStatus = (data.status[statusesCount - 1] || {}).statusName;
        var previousStatus = (data.status[statusesCount - 2] || {}).statusName;

        if (isPaymentMethodWithDeferredStatus(data.payment_method)) {
          // for sms payment in test_mode – we force polling to run at least transactionStatusPollForceRequestsCount times
          var isSmsPaymentMethod = data.payment_method === PaymentMethod.SMS;
          var isCounterFinished = this.transactionStatusPoll.counter >= this.config.transactionStatusPollForceRequestsCount;
          var isPollForced = data.test_mode && isSmsPaymentMethod && !isCounterFinished;

          if (isPollForced) {
            data.epayment_status = TransactionStatus.PENDING;
          } else {
            // default epayment_status is "pending"
            data.epayment_status = TransactionStatus.PENDING;

            if (finalStatus === 'final_error' || finalStatus === 'aborted_by_user') {
              data.epayment_status = TransactionStatus.CANCEL;
            }

            if (finalStatus === 'final_success') {
              data.epayment_status = TransactionStatus.SUCCESS;
            }
          }
        } else {
          var isSodPaymentMethod = data.payment_method === PaymentMethod.SEPA_ONE;
          var isRecurring = !!data.recurring_interval && !!data.subscription_token; // determine status from mapping

          data.epayment_status = finalStatusesMap[finalStatus] || TransactionStatus.ERROR; // handle special cases

          if (finalStatus === 'final_cancel' && previousStatus === 'authorization_success') {
            data.epayment_status = TransactionStatus.SUCCESS;
          }

          if (isSodPaymentMethod && isRecurring && finalStatus === 'final_cancel' && previousStatus === 'success') {
            data.epayment_status = TransactionStatus.SUCCESS;
          }
        }
      } else {
        data.epayment_status = TransactionStatus.ERROR;
      }

      return data;
    } /////////////////////////////////////////////////////////////////////////////

  }, {
    key: "tryStartTransactionStatusPoll",
    value: function () {
      var _tryStartTransactionStatusPoll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(transactionInfo) {
        var hasDeferredStatus, isPending, isTransactionStatusPollRunning;
        return _regeneratorRuntime.wrap(function _callee23$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                hasDeferredStatus = transactionInfo && isPaymentMethodWithDeferredStatus(transactionInfo.payment_method);
                isPending = transactionInfo && transactionInfo.epayment_status === TransactionStatus.PENDING;
                isTransactionStatusPollRunning = this.transactionStatusPoll.isRunning();

                if (!(hasDeferredStatus && isPending && !isTransactionStatusPollRunning)) {
                  _context24.next = 6;
                  break;
                }

                _context24.next = 6;
                return this.transactionStatusPoll.start(transactionInfo.epp_transaction_id);

              case 6:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee23, this);
      }));

      function tryStartTransactionStatusPoll(_x28) {
        return _tryStartTransactionStatusPoll.apply(this, arguments);
      }

      return tryStartTransactionStatusPoll;
    }()
  }, {
    key: "tryStopTransactionStatusPoll",
    value: function () {
      var _tryStopTransactionStatusPoll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(transactionInfo) {
        var hasDeferredStatus, isPending, isTransactionStatusPollRunning;
        return _regeneratorRuntime.wrap(function _callee24$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                hasDeferredStatus = transactionInfo && isPaymentMethodWithDeferredStatus(transactionInfo.payment_method);
                isPending = transactionInfo && transactionInfo.epayment_status === TransactionStatus.PENDING;
                isTransactionStatusPollRunning = this.transactionStatusPoll.isRunning();

                if (!(hasDeferredStatus && !isPending && isTransactionStatusPollRunning)) {
                  _context25.next = 6;
                  break;
                }

                _context25.next = 6;
                return this.transactionStatusPoll.stop();

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee24, this);
      }));

      function tryStopTransactionStatusPoll(_x29) {
        return _tryStopTransactionStatusPoll.apply(this, arguments);
      }

      return tryStopTransactionStatusPoll;
    }()
  }]);

  return Epik;
}(); ///////////////////////////////////////////////////////////////////////////////

var createEpik = function createEpik() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  config = createEpikConfig(config);
  return new Epik({
    config: config
  });
};

export { AllEpikQueryParams, CreditCardIframeMessageType, CreditCardPaymentMethods, CronHelper, Epik, EpikEventName, EpikEventer, EpikQueryParam, EpmsApiProxy, EpmsPaymentStatus, EpmsPaymentStatusReason, EpmsSubscriptionStatus, EppApiProxy, Messenger, OneTimePaymentMethods, Payment, PaymentCurrency, PaymentError, PaymentFlow, PaymentMethod, PaymentMethodsWithDeferredStatus, PaymentProvider, PaymentType, PostFinancePaymentMethods, PseudoRecurringPaymentMethods, RecurringInterval, RecurringPaymentMethods, SubscriptionStatus, TransactionStatus, TransactionStatusPoll, WatchedEpikQueryParams, createCronHelper, createEpik, createEpikConfig, createEpikEvents, createEpmsApiProxy, createEppApiProxy, createPayment, createTransactionStatusPoll, getCreditCardType, getLocationParams, getSupportedPaymentTypes, isCreditCardPaymentMethod, isPaymentMethodWithDeferredStatus, isPaymentTypeSupported, isPostFinancePaymentMethod, isSupportedPaymentMethod, isSupportedPaymentProvider, normalizeValues };
